<template>
  <div class="container-wrapper" ref="wrapperRef" :class="{ 'isMobile': isMobile, 'isKeyboardOpen': isKeyboardOpen }">
    <div class="guide-section">
      <main-panel />
    </div>
    <!-- 对话里的消息 -->
    <template v-if="activeConversation">

      <div v-show="isShowList" v-for="(chat, idx) in activeConversation.messages" :key="getChatKey(chat, idx)"
        class="record-wrap base-button" :class="'record-wrap-' + idx">
        <!-- 新对话 -->
        <div class="chat-message chat-greet" v-if="chat.type === 'new'">
          <span class="msg-content">{{ chat.msg }}</span>
        </div>
        <!-- 用户消息 文字消息 -->
        <div class="chat-message chat-auto user-msg" v-else-if="chat.type === 'my'">
          <div class="img-wrap">
            <img :src="chat.avatar" alt="" />
          </div>
          <div class="content-wrapper" @click="copyQuestion(chat.inputText)">
            <!-- 折叠控制栏 -->
            <div class="msg-header" @click.stop>
              <span class="msg-summary">
                <i></i> ❓ 你的提问
                <span v-if="chat.fileList && chat.fileList.length > 0" class="file-count">
                  ({{ chat.fileList.length }}个文件)
                </span>
              </span>
              <span class="controll-fold" @click.stop="toggleUserCollapse($event, chat)">
                <i v-show="chat.isCollapse" class="collapse el-icon-arrow-right"></i>
                <i v-show="!chat.isCollapse" class="expend el-icon-arrow-right"></i>
              </span>
            </div>

            <!-- 折叠内容（文件、语音、文本） -->
            <div v-show="!chat.isCollapse">
              <template v-if="chat.fileList && chat.fileList.length > 0">
                <!-- 单图 -->
                <div v-if="chat.fileList.length === 1 && chat.fileList[0].isImg" class="img-file-wrap">
                  <el-image :src="chat.fileList[0].iconUrl" :preview-src-list="[chat.fileList[0].iconUrl]" alt="" />
                </div>
                <!-- 多文件或非图片 -->
                <div v-else class="file-wrap">
                  <file-display :fileList="chat.fileList" isMain="true" />
                </div>
              </template>

              <!-- 语音 -->
              <div v-if="chat.fileType === 'voice'" class="voice-wrap" @click.stop="handleChangeAudioVolume">
                <audio-player ref="audio" class="audio-box" :fileurl="chat.voiceUrl"></audio-player>
              </div>

              <!-- 用户文本 -->
              <span class="msg-content my-msg" v-show="chat.msg !== ''">{{ chat.msg }}</span>
            </div>
          </div>
        </div>

        <!-- 客服消息 -->
        <div class="chat-message chat-auto chat-robot" v-else :key="sessionId + idx">
          <div class="img-wrap">
            <img :src="chat.avatar" alt="" />
          </div>
          <div class="content-wrapper">
            <span v-show="chat.msg === 'loading'" class="loading-span msg-content">
              <i class="el-icon-loading"></i>
              <span class="loading-text">排队中…</span>
            </span>
            <div v-show="chat.msg !== 'loading'" class="reply-msg msg-content"
              :class="chat.type === 'knowledgeGraph' ? 'resizableDiv' : ''">
              <div class="reply-content" v-if="chat.msg && robotId !== 'exercise'">
                <p class="result">{{ chat.msg }}</p>
              </div>
              <!-- 交互学习智能体模块 -->
              <template v-else>

                <template v-if="robotId !== 'composition'">

                  <p v-if="chat.parts[0] && chat.parts[0].title" class="ai-title">
                    <template v-if="chat.type === 'knowledgeGraph'">
                      <el-tooltip class="item" effect="dark" placement="right"
                        :content="chat.graphCollect ? '取消收藏' : '收藏图谱'">
                        <div class="collect-graph">
                          <i v-show="!chat.graphCollect" class="el-icon-star-off" style="color: #9dca67;"
                            @click="collectGraph(chat)"></i>
                          <i v-show="chat.graphCollect" class="el-icon-star-on" style="color: #9dca67;"
                            @click="removeGraph(chat)"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <template v-if="chat.type === 'topicmark'">
                      <el-tooltip class="item" effect="dark" placement="right"
                        :content="chat.collectType === 'topic' ? '取消收藏' : '收藏专题'">
                        <div class="collect-graph">
                          <i v-show="chat.collectType !== 'topic'" class="el-icon-star-off" style="color: #9dca67;"
                            @click="collectTopic(chat)"></i>
                          <i v-show="chat.collectType === 'topic'" class="el-icon-star-on" style="color: #9dca67;"
                            @click="removeTopic(chat)"></i>
                        </div>
                      </el-tooltip>
                    </template>
                    <markdown-render :markdown="chat.parts[0].title">
                    </markdown-render>
                    <span class="controll-fold" @click="handleCollapse(chat, 'record-wrap-' + idx)">
                      <i v-show="chat.isCollapse" class="collapse el-icon-arrow-right"></i>
                      <i v-show="!chat.isCollapse" class="expend el-icon-arrow-right"></i>
                    </span>
                  </p>
                  <div v-if="
                    !chat.isCollapse ||
                    (!chat.title && (!chat.parts[0] || !chat.parts[0].title))
                  " class="collapse-section">
                    <!-- 每一part 开始 -->
                    <div v-for="(part, pIndx) in chat.parts" :key="chat.id + 'part' + pIndx">
                      <p v-if="pIndx > 0 && part.title" class="ai-title"></p>
                      <!-- @dblclick="copyQuestion(part.msg, chat)"" -->
                      <div v-show="part.msg" class="markdown-body part-msg">
                        <markdown-render :markdown="part.msg" :key="chat.id + 'msg' + pIndx"> </markdown-render>
                      </div>
                      <div v-show="part.plotly.length > 0" v-for="(p, plotIndex) in part.plotly"
                        :key="'plot' + plotIndex">
                        <plot :plotData="p" :isMobile="isMobile">

                        </plot>
                      </div>

                      <template v-if="chat.type === 'wall'">
                        <bar-echart :dataOption="chat.paintData" @recommandTopic="recommandTopic"></bar-echart>
                      </template>
                      <template v-else-if="chat.type === 'knowledgeGraph'">
                        <knowledge-graph :chat="chat" :sessionId="sessionId" ref="knowledgeRef"
                          @handleModal="handleModal"
                          @handleGraphImagePreview="handleGraphImagePreview"></knowledge-graph>
                      </template>
                      <!-- 收藏本、错题本不按题型排列 -->
                      <template v-else-if="(chat.type === 'questionCollect' || chat.type === 'wrong')">
                        <div class="exercises-wrap">
                          <Question v-for="(question, index) in part.questions" :key="question.nanoid"
                            class="question-item" :showIndex="index" :chat="chat" :index="index" :question="question"
                            :robotId="robotId" @sendEditorAnswer="sendEditorAnswer">
                            <QuizInteractionToolbar slot="operation" :robotId="robotId" :chat="chat"
                              :question="question" :index="index">
                            </QuizInteractionToolbar>
                          </Question>
                        </div>
                        <div v-if="chat.type === 'wrong' && chat.isDone" style="text-align:center; margin-top:12px;">
                        <button class="bueaty-btn" @click="generateDeepReport(chat)">
                          <i class="el-icon-document"></i>
                          生成专属深度研究报告
                        </button>
                        </div>
                      </template>
                      <!-- 收藏本、错题本不按题型排列 -->
                      <!-- 学习交互模块 -->
                      <div v-else class="exercises-wrap">
                        <div v-for="(typeQuestions, key) in part.questions"
                          :class="typeQuestions.count === 0 ? 'first-question' : ''">
                          <Question v-for="(question, index) in typeQuestions.questions" :key="question.nanoid"
                            class="question-item" :showIndex="index + typeQuestions.count" :chat="chat" :index="index"
                            :question="question" :robotId="robotId" @sendEditorAnswer="sendEditorAnswer">
                            <QuizInteractionToolbar slot="operation" :robotId="robotId" :chat="chat"
                              :question="question" :index="index">
                            </QuizInteractionToolbar>

                          </Question>
                        </div>
                      </div>
                      <div class="downloadfile-wrap" v-if="part.filename && part.filename.length > 0">
                        <p v-for="f in part.filename" :key="f">
                          <el-tag @click="downloadFile(f)">
                            {{ f }}
                          </el-tag>
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- 每一part 结束 -->

                  <div class="block_operation" style="text-align: center" v-if="chat.isDone === 1 && chat.blockid">
                    <button class="bueaty-btn" @click="handleTeacherDownload(chat)">
                      <i class="el-icon-download"></i>
                      教师下载
                    </button>
                    <button class="bueaty-btn" @click="handleStudentDownload(chat)">
                      <i class="el-icon-download"></i>
                      学生下载
                    </button>
                  </div>
                </template>
                <!-- @dblclick.stop.prevent="copyQuestion(chat.msg, chat)" -->
                <div v-if="
                  robotId === 'composition' &&
                  chat.msg &&
                  (!chat.title)
                " class="markdown-body">
                  <markdown-render :markdown="chat.msg"> </markdown-render>
                </div>
                <div v-if="robotId === 'composition'">
                  <div class="paper-title" :class="chat.isCollapse ? 'collapse' : ''">
                    <!-- <markdown-render :markdown="chat.title">
                      </markdown-render> -->
                    <div class="title-left">
                      <el-tooltip class="item" effect="dark" placement="top"
                        :content="chat.paperCollect ? '取消收藏' : '收藏试卷'">
                        <span class="collect-wrapper">
                          <i v-show="!chat.paperCollect" class="el-icon-star-off" @click="
                            collectPaper(
                              chat.blockid,
                              chat.title,
                              chat.questions,
                              chat
                            )
                            "></i>
                          <i v-show="chat.paperCollect" class="el-icon-star-on" @click="
                            removePaperCollect(
                              chat.blockid,
                              chat.title,
                              chat.questions,
                              chat
                            )
                            "></i>
                        </span>
                      </el-tooltip>
                      <h2 v-show="!chat.isEditTestTitle" class="uneditable" v-text="chat.title.replace('##', '')"
                        @dblclick="editQuestion($event, chat)">
                      </h2>

                      <h2 v-show="chat.isEditTestTitle" class="editable">
                        <el-input style="width: 300px" v-model="chat.title" autofocus
                          @blur.stop.prevent="saveTestTitle(chat)"></el-input>
                      </h2>
                    </div>

                    <span class="controll-fold" @click="handleCollapse(chat, 'record-wrap-' + idx)">
                      <i v-show="chat.isCollapse" class="collapse el-icon-arrow-right"></i>
                      <i v-show="!chat.isCollapse" class="expend el-icon-arrow-right"></i>
                    </span>
                  </div>
                  <!-- @dblclick.stop.prevent="copyQuestion(chat.msg, chat)" -->
                  <div v-show="chat.msg" class="markdown-body">
                    <markdown-render :markdown="chat.msg"> </markdown-render>
                  </div>
                  <div class="collapse-section" v-if="!chat.isCollapse">
                    <!-- 试卷 start -->
                    <div class="exercises-wrap">
                      <div v-for="(type, i) in chat.questions" :key="i + chat.id" class="draggable-wrapper"
                        :class="type.count === 0 ? 'first-question' : ''">
                        <draggable :list="type.questions" :disabled="!enabled" class="list-group drag-area"
                          ghost-class="ghost" :touch-start-threshold="80" :delay="200" :delay-on-touch-only="true"
                          :key="chat.id + i" :scroll-sensitivity="100" :scroll-speed="10" :move="handleDragMove"
                          item-key="id" :ref="chat.id + type" chosen-class="chose" drag-class="drag"
                          @start="handleDragStart" @end="handleDragEnd(chat)">
                          <Question class="list-group-item question-item" v-for="(question, index) in type.questions"
                            :key="question.nanoid" :chat="chat" :question="question" :robotId="robotId"
                            :showIndex="index + type.count" :index="index" @sendEditorAnswer="sendEditorAnswer">
                            <QuizInteractionToolbar slot="operation" :robotId="robotId" :chat="chat"
                              :question="question" :index="index">
                            </QuizInteractionToolbar>


                          </Question>
                        </draggable>

                      </div>
                    </div>
                  </div>
                  <div style="text-align: center" v-if="chat.isDone === 1 && chat.blockid" class="block_operation">
                    <button v-show="!chat.paperCollect" class="bueaty-btn" @click="
                      collectPaper(
                        chat.blockid,
                        chat.title,
                        chat.questions,
                        chat
                      )
                      ">
                      收藏试卷
                    </button>
                    <button class="bueaty-btn" v-show="chat.paperCollect" @click="
                      removePaperCollect(
                        chat.blockid,
                        chat.title,
                        chat.questions,
                        chat
                      )
                      ">
                      取消收藏
                    </button>
                    <button class="bueaty-btn" :class="chat.isPaperDownloading ? 'disabled' : ''"
                      @click="handlePaperDownload(chat)">
                      <i class="el-icon-download"></i>
                      试卷下载
                    </button>
                    <button class="bueaty-btn" :class="chat.isAnswerDownloadind ? 'disabled' : ''"
                      @click="handleAnswerDownload(chat)">
                      <i class="el-icon-download"></i>
                      答案下载
                    </button>
                  </div>
                  <!-- 试卷 end -->
                </div>
                <loader v-show="chat.isSlow"></loader>
                <div class="ai-picture" v-if="chat.base64 && chat.base64.length > 0">
                  <div class="ai-img-wrap" v-for="img in chat.base64">
                    <el-image :src="img.url" :preview-src-list="[img.url]">
                    </el-image>
                  </div>
                </div>
                <div class="downloadfile-wrap" v-if="chat.filename && chat.filename.length > 0">
                  <p v-for="f in chat.filename" :key="f">
                    <el-tag @click="downloadFile(f)">
                      {{ f }}
                    </el-tag>
                  </p>
                </div>
              </template>
            </div>
            <div v-if="chat.controller && chat.isDone === 0" class="request-abort" @click="abortRequest(chat)"></div>
            <div class="request-fail">
              <div v-if="chat.isDone === 2">
                <span style="color: #b0b7c0; margin-right: 12px">本次回答已被终止</span>
                <button v-show="idx === activeConversation.messages.length - 1" type="primary"
                  icon="el-icon-refresh-right" size="mini" color="#2454ff" @click="retry(chat)">
                  重新生成
                </button>
                <button v-show="idx === activeConversation.messages.length - 1 && !chat.isContinuing" type="primary" size="mini" color="#67c23a" style="margin-left: 8px"
                  @click="continueWrite(chat)">
                  {{ chat.isContinuing ? '续写中...' : '继续生成' }}
                </button>
              </div>

              <div v-if="chat.isDone === 3">
                <span style="color: #b0b7c0; margin-right: 12px">本次回答网络异常</span>
                <button v-show="idx === activeConversation.messages.length - 1" type="primary"
                  icon="el-icon-refresh-right" size="mini" color="#2454ff" @click="retry(chat)">
                  重新生成
                </button>
                <button v-show="idx === activeConversation.messages.length - 1 && !chat.isContinuing" type="primary" size="mini" color="#67c23a" style="margin-left: 8px"
                  @click="continueWrite(chat)">
                  {{ chat.isContinuing ? '续写中...' : '继续生成' }}
                </button>
              </div>
              <div v-if="chat.isDone === 500">
                <span style="color: #b0b7c0; margin-right: 12px">本次回答服务器异常</span>
                <button v-show="idx === activeConversation.messages.length - 1" type="primary"
                  icon="el-icon-refresh-right" size="mini" color="#2454ff" @click="retry(chat)">
                  重新生成
                </button>
                <button v-show="idx === activeConversation.messages.length - 1 && !chat.isContinuing" type="primary" size="mini" color="#67c23a" style="margin-left: 8px"
                  @click="continueWrite(chat)">
                  {{ chat.isContinuing ? '续写中...' : '继续生成' }}
                </button>
              </div>
            </div>
            <!---
            <div
              v-if="chat.isDone === 1 && getSpeakText(chat)"
              class="speaker-icon"
              :class="{ speaking: speakingChatId === chat.id }"
              @click="speakMessage(chat)"
            >
              {{ speakingChatId === chat.id ? '⏸' : '🔊' }}
            </div>
            --->

            <!-- 推荐的问题 -->
            <div v-if="chat.recommend && chat.recommend.length > 0" class="recommend-qs">
              <div class="recommend-item" v-for="(item, qIdx) in chat.recommend" :key="qIdx"
                @click="sendQuestion(item)">
                <markdown-render :markdown="item"></markdown-render>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- 虚拟文件内容查看弹窗 -->
    <el-dialog 
      title="文件内容" 
      :visible.sync="virtualFileDialogVisible" 
      width="70%"
      :close-on-click-modal="true"
      append-to-body
    >
      <div style="max-height: 400px; overflow-y: auto; white-space: pre-wrap; word-break: break-all; font-family: monospace;">
        {{ virtualFileContent }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="virtualFileDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog v-loading="selectedQuestion && selectedQuestion.loading" title="添加与上一题同类型（单选、多选、填空、解答）题目" width="40%" top="16vh"
      class="replaceByPointDialog" :visible.sync="addQuestionVisible" :append-to-body="true">
      <el-input class="knowledge-point" v-model="addText" autocomplete="off" placeholder="请输入知识点" type="textarea"
        :autosize="{ minRows: 6, maxRows: 12 }"></el-input>
      <div slot="footer" class="dialog-footer base-button">
        <button @click="addQuestionVisible = false" style="margin-right: 10px">
          取 消
        </button>
        <button type="primary" @click="
          addQuestionByPoint
        ">
          提 交
        </button>
      </div>
    </el-dialog>
    <el-dialog top="30vh" title="提示" :visible.sync="delQuestionVisible" class="delDialog" width="30%"
      :append-to-body="true">
      <div class="warn-info">
        <i class="el-icon-warning logout-warning"></i> 确定删除本题吗？
      </div>
      <div slot="footer" class="dialog-footer base-button">
        <button @click="delQuestionVisible = false">取 消</button>
        <button :disable="isLoading" type="primary" @click="handleQuestionDel">确 定</button>
      </div>
    </el-dialog>
    <ImageEnlarge :src="enlargeSrc" ref="enlarge" v-if="isModalShow" @handleModal="handleModal">

    </ImageEnlarge>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import pubsub from "pubsub-js";
import md from "@/utils/markdown/md";
import draggable from "vuedraggable";

// 解析公式
import fileDisplay from "@/components/chat/fileDisplay.vue";
import mainPanel from "@/components/chat/panel/mainPanel.vue";
import barEchart from "@/components/echart/barEchart.vue";
import KnowledgeGraph from "@/components/d3/KnowledgeGraph.vue";
import Plot from "@/components/echart/plotly"
import humenAvatar from "@/assets/image/chat/humen.svg";
import loader from "@/components/loader/index.vue";
import AudioPlayer from "@/components/record/audioPlayer.vue";
import Question from "@/components/question/question.vue";
import QuizInteractionToolbar from "../question/QuizInteractionToolbar.vue";
import ImageEnlarge from "@/components/ImageEnlarge.vue"
import * as D3 from "d3";
import _ from "lodash";

// import katex from "katex";
import {
  ApiService
} from "@/api/fetch/apiService"
import { nanoid } from "nanoid";
import { resetQuestionStandardAnswer } from "@/utils/question/AnswerService"
import { initQuestion, initQuestionForList, resetQuestionIndex } from "@/utils/question/QuestionInitializer"
import { collectGraph, removeGraph } from "@/api/chat/knowledgeGraph"
import { showGraph } from "@/api/chat/knowledgeGraph";
import { getLevel } from '@/utils/chat/chatUtil';

import { createAutoMsg } from '@/utils/chat/autoMsg'
import chatMixin from "@/mixin/chat.js";
import MarkdownRender from "@/components/MarkdownRender.vue";
import * as chatApi from "@/api/chat/sendReceive";
import { removeTopic } from "../../api/chat/sendReceive";

import { handleMathData } from "@/api/fetch/mathService"
import { handlePaper } from "@/api/fetch/mathService";
import { handleChatParams, hanldeWallParams, handleSimilarParams} from "@/utils/fetch/StreamProcessor";

const cubic = value => Math.pow(value, 3);
const easeInOutCubic = value => value < 0.5
  ? cubic(value * 2) / 2
  : 1 - cubic((1 - value) * 2) / 2;

export default {
  data() {
    return {
      needNewSessionToken: null,    // "切换智能体无会话"事件的订阅句柄
      _gettingRouteInfo: false,    // getRouteInfo 防重入锁
      // 虚拟文件查看弹窗
      virtualFileDialogVisible: false,
      virtualFileContent: '',
      stopSubscriptionToken: null,
      focusTimer: null,
      keyboardTimer: null,
      lastViewportHeight: 0,
      lastWindowHeight: 0,
      isKeyboardVisible: false, // 新增状态，避免重复触发


      isSpeaking: false,
      speechUtterance: null,
      speakingChatId: null,
      startTime: 0,
      endTime: 0,
      md: md,
      timer: null,
      addwaterUrl: "",
      showAnserPanel: false,
      testFormula: "\\frac{1}{3}\\pi {r}^{2}h = 3\\sqrt{3}\\pi",
      isCollectLoading: false,
      isWrongLoading: false,
      isWallLoading: false,
      isCreateLoading: false,
      isPaperLoading: false,
      isTopicLoading: false,
      collectFormVisible: false,
      sessionId: "",
      addText: "",
      addQuestionVisible: false,
      selectedQuestion: {},
      selectedChat: {},
      selectedIndex: 0,
      delQuestionVisible: false,
      isLoading: false,
      dragging: false,
      enabled: true,
      globalIndexMap: {},
      handleCopyCode: () => { },
      handleTextClick: () => { }, // 后端标志的文本
      imagePreview: () => { },
      imageObserver: null,
      scrollInterval: null, // 滚动定时器
      scrollSpeed: 8, // 滚动速度
      scrollThreshold: 50,// 距离边界触发滚动的阈值(px)
      currentMouseY: 0,
      currentMoveElement: {},
      scrollThresholdRatio: 0.2,
      containerResizeObserver: null,
      enlargeSrc: "",
      isModalShow: false,
      visibilityCheckTimer: null,  // 存储当前正在进行的消息的检查定时器
      pendingChat: null,           // 记录正在等待检查的chat对象引用
    };
  },
  computed: {
    route() {
      return this.$route;
    },


    activeConversationId() {
      return this.activeConversation?.id;
    },


    chatSize() {
      return this.activeConversation && this.activeConversation.messages && this.activeConversation.messages.length

    },
    isShowList() {
      if (this.robotId === "composition" && this.chatSize) return true;
      // 对练习题智能体，2条消息即可显示（新会话 + 每日一题）
      if ((this.robotId === "exercises" || this.robotId === "mexercises") && this.chatSize >= 2) return true;
      return this.chatSize >= 3;
    },

    ...mapState(["robots", "papers", "foldHistory", "foldRobot", "isMobile", "isKeyboardOpen", "conversations", "activeConversation"]),
  },
  components: {
    fileDisplay,
    loader,
    AudioPlayer,
    mainPanel,
    barEchart,
    MarkdownRender,
    Question,
    QuizInteractionToolbar,
    KnowledgeGraph,
    Plot,
    draggable,
    ImageEnlarge
  },
  mixins: [chatMixin],
  provide() {
    return {
      callGrandfatherAddQuestion: this.openPointAddDialog,
      callGrandfatherRemoveQuestion: this.openPointDeleteDialog,
      callGrandfatherUpdateQuestion: this.updateQuestion
    }
  },
  created() { },
  // props: ["sessionId", "robotId"],
  mounted() {
    this.stopSubscriptionToken = pubsub.subscribe('stopGeneration', (msg, chat) => {
      this.abortRequest(chat);
    });
    this.subscribeReceiveDone();
    // 获取列表
    this.subscribeMyQuestions();
    // 展示试卷
    this.subscribeGetPaper();
    // 展示图谱
    this.subscribeGetGraph();
    // 展示专题
    this.subscribeGetTopic();
    // ★ 新增：订阅“切换智能体但无会话”事件
    this.needNewSessionToken = pubsub.subscribe('needNewSession', async (msg, { robotId }) => {
        await this.handleSwitchNewSession(robotId);
    });
    this.setWidth();
    window.addEventListener('resize', this.setWidth)
    this.setupContainerObserver();
    this.copyCode();
    this.handleInteractiveClick();
    this.handleImagePreview();
    this.getRouteInfo();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    if (this.isMobile) {
      // 方案1：focusin 监听（主要，兼容性最好）
      document.addEventListener('focusin', this.onFocusIn);
      document.addEventListener('focusout', this.onFocusOut);
      
      // 方案2：visualViewport 监听（辅助，用于键盘弹起时调整UI）
      this.initKeyboardDetection();
    }


  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setWidth)
    document.removeEventListener('click', this.handleTextClick)
    document.removeEventListener('click', this.handleCopyCode)
    document.removeEventListener('click', this.imagePreview)
    this.stopContainerObserver();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.clearVisibilityTimer();
    if (this.stopSubscriptionToken) {
      pubsub.unsubscribe(this.stopSubscriptionToken);
      this.stopSubscriptionToken = null;
    }
    this.stopSpeak(); // 【新增】页面销毁时停止朗读
    window.speechSynthesis.cancel(); // 彻底终止所有朗读任务
    this.speakingChatId = null;

    document.removeEventListener('focusin', this.onFocusIn);
    document.removeEventListener('focusout', this.onFocusOut);
    this.destroyKeyboardDetection();
    clearTimeout(this.focusTimer);
    clearTimeout(this.keyboardTimer);
    // ★ 新增：取消 needNewSession 订阅
    if (this.needNewSessionToken) {
        pubsub.unsubscribe(this.needNewSessionToken);
        this.needNewSessionToken = null;
      }
    },
  activated() {
    // this.getRouteInfo();

  },
  deactivated() { },
  methods: {

      async toggleUserCollapse(event, chat) {
        const container = this.$refs.wrapperRef?.parentElement; // 滚动容器
        let scrollTop = 0;
        if (container) {
          scrollTop = container.scrollTop; // 记录当前滚动位置
        }
        chat.isCollapse = !chat.isCollapse;
        await this.$store.dispatch('updateMessageToConversation', { message: chat });
        if (container) {
          this.$nextTick(() => {
            container.scrollTop = scrollTop; // 恢复滚动位置
          });
        }
      },

      // 解析消息，提取虚拟文件和用户问题
      parseUserMessage(msg) {
          try {
              if (!msg) return { files: [], userQuestion: '' };
              if (typeof msg !== 'string') msg = String(msg);

              const hasFileMark = msg.includes('【长文本_');
              const userQuestionIndex = msg.indexOf('【用户问题】');

              let filesPart = msg;
              let userQuestion = '';

              if (userQuestionIndex !== -1) {
                  filesPart = msg.substring(0, userQuestionIndex);
                  userQuestion = msg.substring(userQuestionIndex + '【用户问题】'.length).trim();
              } else {
                  if (!hasFileMark) {
                      return { files: [], userQuestion: msg };
                  } else {
                      userQuestion = '';
                      filesPart = msg;
                  }
              }

              const fileRegex = /【长文本_([^】]+)】\s*([\s\S]*?)(?=【长文本_|【用户问题】|$)/g;
              const files = [];
              let match;
              while ((match = fileRegex.exec(filesPart)) !== null) {
                  const fileName = match[1].trim();
                  const content = match[2].trim();
                  if (content) {
                      files.push({ fileName, content });
                  }
              }
              return { files, userQuestion };
          } catch (e) {
              console.error('parseUserMessage error:', e);
              return { files: [], userQuestion: msg || '' };
          }
      },

      // 复制消息：用户消息只复制用户问题
      copyQuestion(question) {
        pubsub.publish("copyText", question);
      },

      // 查看虚拟文件内容（复用已有弹窗）
      viewVirtualFile(file) {
          if (file && file.content) {
              this.virtualFileContent = file.content;
              this.virtualFileDialogVisible = true;
          } else {
              this.$message.warning('该文件无内容');
          }
      },
      handleViewVirtualFile(file) {
        if (file.isVirtual && file.content) {
          this.virtualFileContent = file.content;
          this.virtualFileDialogVisible = true;
        } else {
          this.$message.warning('该文件无法预览');
        }
      },
    
      // ====== 方案1：focusin/focusout（主要） ======
      onFocusIn(e) {
        const el = e.target;
        if (['INPUT', 'TEXTAREA'].includes(el.tagName)) {
          // 更新键盘状态
          this.$store.commit('setKeyboardOpen', true);
          this.isKeyboardVisible = true;
          
          // 防抖处理
          clearTimeout(this.focusTimer);
          this.focusTimer = setTimeout(() => {
            // 滚动输入框到可视区域
            el.scrollIntoView({ block: 'center', behavior: 'smooth' });
            
            // 额外：如果输入框在底部固定，可滚动整个页面
            // window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
          }, 180);
        }
      },
      
      onFocusOut(e) {
        const el = e.target;
        if (['INPUT', 'TEXTAREA'].includes(el.tagName)) {
          // 延迟恢复，避免键盘切换时闪烁
          clearTimeout(this.keyboardTimer);
          this.keyboardTimer = setTimeout(() => {
            this.$store.commit('setKeyboardOpen', false);
            this.isKeyboardVisible = false;
          }, 300);
        }
      },
      
      // ====== 方案2：visualViewport（辅助） ======
      initKeyboardDetection() {
        if (window.visualViewport) {
          this.lastViewportHeight = window.visualViewport.height;
          window.visualViewport.addEventListener('resize', this.onViewportResize);
        } else {
          this.lastWindowHeight = window.innerHeight;
          window.addEventListener('resize', this.onWindowResize);
        }
      },
      
      destroyKeyboardDetection() {
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', this.onViewportResize);
        } else {
          window.removeEventListener('resize', this.onWindowResize);
        }
      },
      
      onViewportResize() {
        const currentHeight = window.visualViewport.height;
        const diff = this.lastViewportHeight - currentHeight;
        
        if (diff > 80) {
          // 键盘弹起（如果 focusin 未触发）
          if (!this.isKeyboardVisible) {
            this.$store.commit('setKeyboardOpen', true);
            this.isKeyboardVisible = true;
            
            // 兜底滚动
            clearTimeout(this.focusTimer);
            this.focusTimer = setTimeout(() => {
              const inputEl = document.querySelector('input, textarea');
              if (inputEl && document.activeElement === inputEl) {
                inputEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
              }
            }, 200);
          }
        } else if (diff < -80) {
          // 键盘收起
          if (this.isKeyboardVisible) {
            this.$store.commit('setKeyboardOpen', false);
            this.isKeyboardVisible = false;
          }
        }
        this.lastViewportHeight = currentHeight;
      },
      
      onWindowResize() {
        const currentHeight = window.innerHeight;
        const diff = this.lastWindowHeight - currentHeight;
        
        if (diff > 80) {
          if (!this.isKeyboardVisible) {
            this.$store.commit('setKeyboardOpen', true);
            this.isKeyboardVisible = true;
            clearTimeout(this.focusTimer);
            this.focusTimer = setTimeout(() => {
              const inputEl = document.querySelector('input, textarea');
              if (inputEl && document.activeElement === inputEl) {
                inputEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
              }
            }, 200);
          }
        } else if (diff < -80) {
          if (this.isKeyboardVisible) {
            this.$store.commit('setKeyboardOpen', false);
            this.isKeyboardVisible = false;
          }
        }
        this.lastWindowHeight = currentHeight;
      },

      // 提取纯文本（去除markdown符号）
      getSpeakText(chat) {
        let raw = '';
        if (chat.msg && typeof chat.msg === 'string' && chat.msg !== 'loading') {
          raw = chat.msg;
        }
        if (!raw && chat.parts && chat.parts.length) {
          raw = chat.parts.map(p => p.msg || '').join(' ').trim();
        }
        if (!raw) return '';

        let clean = raw
          // 移除全部<style>样式块（thinking/math动画样式全覆盖）
          .replace(/<style[\s\S]*?<\/style>/gi, '')
          .replace(/<script[\s\S]*?<\/script>/gi, '')
          // 删除所有HTML标签（残缺div/span/动态id全部清除）
          .replace(/<\/?[a-zA-Z0-9_-]+(\s+[^>]*?)?\/?>/gi, '')
          // markdown代码块清除
          .replace(/```[\s\S]*?```/g, '')
          // markdown符号过滤
          .replace(/[#*_~>`\[\]()!{}|\\]/g, '')
          // 清除所有emoji
          .replace(/[\u{1F000}-\u{1FFFF}\u{2600}-\u{27FF}]/gu, '')
          // 仅保留中文、英文、数字、常规标点
          .replace(/[^\u4e00-\u9fa5a-zA-Z0-9，。！？；：、·…—()（）【】《》""''\s]/g, '')
          // 压缩多余空格
          .replace(/\s+/g, ' ')
          .trim();

        // 长度截断，避免超长文本报错
        const MAX_READ_LEN = 1800;
        if (clean.length > MAX_READ_LEN) {
          clean = clean.slice(0, MAX_READ_LEN) + '……内容过长已截断';
        }

        // 纯标点/空白判定，返回空
        const emptyTextReg = /^[\s，。！？；：、·…—()（）【】《》""'']*$/;
        if (emptyTextReg.test(clean)) return '';

        return clean;
      },

      // 停止朗读 统一方法
      stopSpeak() {
        window.speechSynthesis.cancel();
        this.speakingChatId = null;
      },

      async speakMessage(chat) {
        const text = this.getSpeakText(chat);
        if (!text) {
          this.$message.warning('暂无可朗读的有效文字');
          return;
        }

        // 点击同一消息暂停
        if (this.speakingChatId === chat.id) {
          this.stopSpeak();
          return;
        }
        this.stopSpeak();

        if (!window.speechSynthesis) {
          this.$message.warning('当前浏览器不支持语音朗读，请使用Chrome/Edge');
          return;
        }

        const utter = new SpeechSynthesisUtterance(text);
        const hasChinese = /[\u4e00-\u9fa5]/.test(text);
        // 先预设语言
        utter.lang = hasChinese ? 'zh-CN' : 'en-US';
        utter.rate = 1;
        utter.pitch = 1;
        utter.volume = 1; // 固定合法音量

        const resetState = () => {
          this.speakingChatId = null;
        };
        utter.onend = resetState;
        utter.onerror = (e) => {
          resetState();
          if (['canceled', 'interrupted'].includes(e.error)) return;
          
          console.error('语音错误详情：', e);
          if (e.error === 'voice-unavailable' || e.error === 'synthesis-failed') {
            this.$message.error('未检测到可用中文语音包，请在系统设置下载语音后重试');
          } else if (e.error === 'text-too-long') {
            this.$message.error('文本过长，无法朗读');
          } else {
            this.$message.error(`朗读失败：${e.error}`);
          }
        };

        this.speakingChatId = chat.id;

        // 封装等待语音加载Promise，解决时序问题
        const loadVoices = () => {
          return new Promise((resolve) => {
            const voices = window.speechSynthesis.getVoices();
            if (voices.length) return resolve(voices);
            // 监听加载，最多等待1.5s防止卡死
            const timer = setTimeout(() => {
              window.speechSynthesis.removeEventListener('voiceschanged', handler);
              resolve(window.speechSynthesis.getVoices());
            }, 1500);
            const handler = () => {
              clearTimeout(timer);
              window.speechSynthesis.removeEventListener('voiceschanged', handler);
              resolve(window.speechSynthesis.getVoices());
            };
            window.speechSynthesis.addEventListener('voiceschanged', handler);
          });
        };

        // 等待语音列表加载完成
        const voices = await loadVoices();
        let targetVoice = null;
        // 优先匹配对应语言语音
        if (hasChinese) {
          targetVoice = voices.find(v => v.lang.includes('zh'));
          // 无中文语音，强制切换系统任意可用语音兜底
          if (!targetVoice && voices.length) {
            targetVoice = voices[0];
            utter.lang = targetVoice.lang;
            this.$message.info('未找到中文语音，将使用系统默认语音朗读');
          }
        } else {
          targetVoice = voices.find(v => v.lang.startsWith('en')) || voices[0];
        }

        if (targetVoice) utter.voice = targetVoice;
        // 仍无任何语音直接报错
        if (!voices.length) {
          resetState();
          this.$message.error('当前设备无任何语音包，无法使用朗读功能');
          return;
        }

        window.speechSynthesis.speak(utter);
      },

      getChatTitle(chat) {
        return chat.title || chat.parts?.[0]?.title || '';
      }, 
      async generateDeepReport(chat) {
      // 收集当前错题本中的所有题目ID
      const questionIds = [];
      if (chat.parts && chat.parts[0] && chat.parts[0].questions) {
        // 根据实际数据结构，part.questions 是数组
        chat.parts[0].questions.forEach(q => {
          if (q.id) questionIds.push(q.id);
        });
      }
      if (questionIds.length === 0) {
        this.$message.warning('当前错题本暂无题目');
        return;
      }

      // 根据当前智能体决定报告的 type 和 avatar
      // this.robotId 为 'exercises'（高中）或 'mexercises'（初中）
      const robotId = this.robotId;
      const robot = this.robots[robotId]; // 对应 robot.js 中的定义
      if (!robot) {
        this.$message.error('未找到当前智能体信息');
        return;
      }

      // 创建一条新的消息对象，模拟高中/初中智能体回复
      const reportMsg = createAutoMsg(robot.avatar, this.$delete);
      reportMsg.type = robotId;             // 重要：与当前智能体类型一致
      reportMsg.sessionId = this.sessionId;
      reportMsg.robotId = robotId;
      reportMsg.msg = 'loading';
      reportMsg.controller = new AbortController();
      reportMsg.isDone = 0;
      reportMsg.params = { 
          questionIds, 
          sessionId: this.sessionId,
          signal: reportMsg.controller.signal
      };

      reportMsg.deepResearch = true;
      reportMsg.retry = ApiService.fetchDeepResearch;

      // 将消息添加到对话中，开始流式渲染
      await this.$store.dispatch('addMessageToConversation', { message: reportMsg });

      try {
        await ApiService.fetchDeepResearch(reportMsg);
      } catch (error) {
        reportMsg.isDone = 3; // 标记网络异常
        reportMsg.msg = '报告生成失败，请稍后重试';
        await store.dispatch('updateMessageToConversation', { message: reportMsg });
      }
    },

    // 清除定时器
    clearVisibilityTimer() {
      if (this.visibilityCheckTimer) {
        clearTimeout(this.visibilityCheckTimer);
        this.visibilityCheckTimer = null;
        this.pendingChat = null;
      }
    },

    // 页面可见性变化处理
    handleVisibilityChange() {
      if (!this.isMobile) return;
      if (document.visibilityState === 'visible') {
        // 从后台返回，查找最后一条正在进行中的机器人消息
        const messages = this.activeConversation?.messages;
        if (!messages || messages.length === 0) return;
        const lastBotMsg = [...messages].reverse().find(
          m => m.type !== 'my' && m.type !== 'new' && m.isDone === 0 && m.controller
        );
        if (!lastBotMsg) return;

        // 清除上一个未完成的定时器
        this.clearVisibilityTimer();

        // 启动5秒超时检查
        this.pendingChat = lastBotMsg;
        this.visibilityCheckTimer = setTimeout(() => {
          if (this.pendingChat && this.pendingChat.isDone === 0) {
            // 超时仍无响应，触发终止
            this.abortRequest(this.pendingChat);
          }
          this.clearVisibilityTimer();
        }, 30000);
      } else {
        // 进入后台，取消定时器（不需要等待）
        this.clearVisibilityTimer();
      }
    },

    async continueWrite(chat) {
      if (chat.isContinuing) return;
      chat.isContinuing = true;
      chat._aborted = false;
      this.clearVisibilityTimer();

      const title = this.getChatTitle(chat);
      if (!title && chat.type === 'composition') {
          this.$message.warning('请先填写试卷标题');
          chat.isContinuing = false;
          return;
      }
      chat.params.title = title;

      // 检查续写所需参数
      const hasValidParams = chat.params && (
        chat.params.text ||
        (chat.params.fileList && chat.params.fileList.length > 0)
      );

      if (chat.deepResearch) {
        if (!chat.params || !chat.params.questionIds) {
          this.$message.error("无法续写：缺少题目列表");
          chat.isContinuing = false;
          return;
        }
      } else if (!hasValidParams) {
        this.$message.error("无法续写：缺少原始请求参数（文本或文件）");
        chat.isContinuing = false;
        return;
      }

      // 重置状态
      chat.isDone = 0;
      chat.controller = new AbortController();
      chat.params.signal = chat.controller.signal;
      chat.params.continue = true;
      chat.params.title = title; // 确保续写时也携带 title

      // 提取已有内容
      let existingContent = chat.msg || '';
      if (!existingContent && chat.parts?.length) {
        existingContent = chat.parts.map(p => p.msg || '').join('\n\n');
      }
      chat.params.existingContent = existingContent;

      // 根据消息类型选择 API
      let apiCall;
      if (chat.deepResearch) {
        apiCall = ApiService.fetchDeepResearch;
        await apiCall(chat);
      } else {
        if (this.robotId === "knowledgeGraph") {
          apiCall = ApiService.fetchKnowledgeReport;
        } else {
          apiCall = ApiService.fetchMathData;
        }
        await apiCall({ aiContent: chat });
      }

      chat.isContinuing = false;
      if (chat.params) {
        delete chat.params.continue;
        delete chat.params.existingContent;
      }
    },

    initCopyCode() {
      this.handleCopyCode = async (e) => {
        if (e.target.classList.contains('copy-btn')) {

          const targetElement = e.target.parentElement.nextElementSibling;
          const code = decodeURIComponent(targetElement.innerText); // 解码获取原始代码
          try {
            await navigator.clipboard.writeText(code);
            this.$message.success('已复制!');
          } catch (err) {
            console.error('复制失败:', err);
            this.$message.warning('复制失败');
          }
        }

      }
    },
    initTextClick() {
      this.handleTextClick = async (e) => {
        const target = e.target.closest('.interactive-text');
        if (!target) return;
        const payload = target.dataset.payload;

        // ★★★ 修复：组件 sessionId 未同步时，从 store 兜底取（store 在 newSession 中最早写入） ★★★
        if (!this.sessionId && this.$store.state.sessionId) {
          this.sessionId = this.$store.state.sessionId;
        }
        // 兜底后仍无会话（极端情况：newSession 还没完成或失败）
        if (!this.sessionId || !this.activeConversation) {
          // 最后手段：从当前活跃会话取 id
          const convId = this.activeConversation?.id || this.$store.getters.activeConversation?.id;
          if (convId) {
            this.sessionId = convId;
          } else {
            this.$message.warning('会话初始化中，请稍后重试');
            return;
          }
        }
        // ★★★ 修复结束 ★★★

        let electricaiMsg = createAutoMsg(
          this.robots[this.robotId].avatar,
          this.$delete
        );
        let { sessionId, robotId } = this;
        electricaiMsg.retry = ApiService.fetchMathData;
        electricaiMsg.remmandType = "";
        electricaiMsg.sessionId = sessionId;
        electricaiMsg.robotId = robotId;
        electricaiMsg.params = {
          text: payload,
          sessionId,
          fileList: []
        };
        // 添加用户消息到对话
        await this.$store.dispatch('addMessageToConversation', {
          message: electricaiMsg
        });
        ApiService.fetchMathData({
          aiContent: electricaiMsg,
        });
      }
    },

    // 获取chat的key
    getChatKey(chat, idx) {
      if (chat.id) {
        return chat.id
      }
      return 'chat' + idx

    },

    // 根据nanoid获取全局序号
    getGlobalIndex(nanoid) {
      if (!this.globalIndexMap[nanoid]) {
        this.$set(this.globalIndexMap, nanoid, -1)
      }
      let count = this.globalIndexMap[nanoid]++
      this.$set(this.globalIndexMap, nanoid, count)

      return this.globalIndexMap[nanoid]
    },

    // 生成key

    getNanoid() {
      return nanoid(4)
    },
    // 容器尺寸变化监听
    setupContainerObserver() {
      const container = document.querySelector('.chat-container');
      if (!container) return;

      this.stopContainerObserver();

      this.containerResizeObserver = new ResizeObserver(entries => {
        this.containerRect = entries[0].contentRect;
      });

      this.containerResizeObserver.observe(container);
      this.containerRect = container.getBoundingClientRect();
    },

    stopContainerObserver() {
      if (this.containerResizeObserver) {
        this.containerResizeObserver.disconnect();
        this.containerResizeObserver = null;
      }
    },

    // 拖拽开始
    handleDragStart(evt) {
      this.dragging = true;
      this.setupContainerObserver(); // 确保容器尺寸最新
      this.startAutoScroll();
    },

    // 拖拽结束
    handleDragEnd(chat) {
      this.dragging = false;
      chat.paperCollect = false;
      this.stopAutoScroll();
      store.dispatch("updateMessageToConversation", {
        message: chat
      })
    },

    // 优化后的滚动逻辑
    startAutoScroll() {
      this.stopAutoScroll();
      if (!this.containerRect) return;

      const scrollLoop = () => {
        if (!this.dragging) return;

        // 动态计算阈值（容器高度的20%）
        const scrollThreshold = this.containerRect.height * this.scrollThresholdRatio;

        // 计算鼠标在容器内的相对位置
        const mouseInContainerY = this.currentMouseY - this.containerRect.top;

        // 顶部滚动 (添加10px缓冲)
        if (mouseInContainerY < scrollThreshold + 10) {
          const scrollIntensity = 1 - (mouseInContainerY / scrollThreshold);
          document.querySelector('.chat-container').scrollTop -= this.scrollSpeed * scrollIntensity;
        }
        // 底部滚动 (添加10px缓冲)
        else if (mouseInContainerY > this.containerRect.height - scrollThreshold - 10) {
          const distanceToBottom = this.containerRect.height - mouseInContainerY;
          const scrollIntensity = 1 - (distanceToBottom / scrollThreshold);
          document.querySelector('.chat-container').scrollTop += this.scrollSpeed * scrollIntensity;
        }

        this.scrollRAF = requestAnimationFrame(scrollLoop);
      };

      this.scrollRAF = requestAnimationFrame(scrollLoop);
    },

    // 增强的鼠标追踪
    handleDragMove(evt) {
      this.currentMoveElement = evt;

      // 统一获取坐标方法
      const getCoordinates = e => {
        if (e.touches && e.touches[0]) return e.touches[0];
        if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0];
        return e;
      };

      const event = evt.originalEvent || evt;
      const coords = getCoordinates(event);
      this.currentMouseY = coords.clientY;

      // 主动触发滚动检查
      if (this.dragging && this.scrollRAF === null) {
        this.startAutoScroll();
      }
    },

    stopAutoScroll() {
      if (this.scrollRAF) {
        cancelAnimationFrame(this.scrollRAF);
        this.scrollRAF = null;
      }
      this.stopContainerObserver();
    },

    // 收藏图谱
    async collectGraph(chat) {
      let kgid = chat.kgId
      let res = await collectGraph({ kgid });
      let flag = 200 <= res.status && res.status < 300;
      if (!res || !flag) {
        this.$message.error("收藏失败");
        return;
      }
      if (flag) {
        chat.graphCollect = true;
        this.$message.success("收藏成功");
      }
    },
    // 移除收藏
    async removeGraph(chat) {
      let kgid = chat.kgId
      let res = await removeGraph({ kgid });
      let flag = 200 <= res.status && res.status < 300;
      if (!res || !flag) {
        this.$message.error("取消失败");
        return;
      }
      if (flag) {
        chat.graphCollect = false;
        this.$message.success("取消成功");
      }
    },

    // 收藏专题
    async collectTopic(chat) {
      let title = chat.parts[0] && chat.parts[0].title
      let res = await chatApi.collectTopic({ title, level: getLevel() });
      let flag = 200 <= res.status && res.status < 300;
      if (!res || !flag) {
        this.$message.error("收藏失败");
        return;
      }
      if (flag) {
        chat.collectType = "topic";
        this.$message.success("收藏成功");
      }
    },
    // 移除收藏
    async removeTopic(chat) {
      let title = chat.parts[0] && chat.parts[0].title
      let res = await chatApi.removeTopic({ title, level: getLevel() });
      let flag = 200 <= res.status && res.status < 300;
      if (!res || !flag) {
        this.$message.error("取消失败");
        return;
      }
      if (flag) {
        chat.collectType = "";
        this.$message.success("取消成功");
      }
    },
    // 调整伸缩图标随元素滚动的现象
    handleScrollResize(resizableDiv) {
      // 动态调整图标位置
      resizableDiv.style.setProperty('--scroll-top', `${resizableDiv.scrollTop}px`);
      resizableDiv.style.setProperty('--scroll-left', `${resizableDiv.scrollLeft}px`);

    },
    adjustBounds(element, index) {
      const rect = element.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      if (rect.right > windowWidth - 52) {
        element.style.width = `${windowWidth - rect.left - 52}px`;
      }

      this.$nextTick(() => {
        // 消除影响（避免全屏的时候还是按照对话框的svg的大小）

        let svgWrap = element.querySelector('.knowledge-graph');
        if (!svgWrap) return
        let svgEle = svgWrap.querySelector('.graph-svg');
        if (!svgEle || !this.$refs.knowledgeRef[index]) {
          return
        }
        // 添加 CSS 类
        svgWrap.classList.add('svg-wrap');
        const currentTransform = D3.zoomTransform(this.$refs.knowledgeRef[index].$svg.node());
        // 添加 CSS 类
        svgEle.classList.add('graph-svg-custom');
        // 保持当前变换状态
        this.$refs.knowledgeRef[index].$svg
          .attr("width", '100%')
          .attr("height", '100%')
          .call(this.$refs.knowledgeRef[index].zoom.transform, currentTransform);
      })
    },
    handleResize: _.debounce(function() {
        const eles = document.querySelectorAll('.resizableDiv');
        if (!eles || eles.length === 0) return;
        
        eles.forEach((ele, index) => {
            // 1. 移除旧的 scroll 监听（防止叠加）
            ele.removeEventListener('scroll', this.handleScrollResize);
            // 重新绑定
            ele.addEventListener('scroll', () => {
                this.handleScrollResize(ele);
            });

            // 2. 关键修复：防止 Observer 重复创建导致内存泄漏
            if (!ele._resizeObserver) {
                const observer = new MutationObserver(() => {
                    this.adjustBounds(ele, index);
                });
                observer.observe(ele, { 
                    attributes: true, 
                    attributeFilter: ['style'] 
                });
                // 标记已创建，避免下次消息进来再创建一个
                ele._resizeObserver = observer; 
            }
        });
    }, 300), // 300ms 防抖

    handleIsFold() {
      this.setWidth();
      const eles = document.querySelectorAll('.resizableDiv');
      if (!eles || eles.length === 0) return
      eles.forEach((ele, index) => {
        this.adjustBounds(ele, index)
      });

    },
    // 计算msg-content的最大宽度

    setWidth() {
      let robotPanel = document.querySelector('#robot-panel');
      let historyPanel = document.querySelector('#history-panel');
      if (robotPanel) {
        console.log('robot',robotPanel.offsetWidth)
        document.documentElement.style.setProperty('--robot-width', `${robotPanel.offsetWidth}px`);

      } else {
        document.documentElement.style.setProperty('--robot-width', `0px`);

      }
      if (historyPanel) {
        console.log('history', historyPanel.offsetWidth)
        document.documentElement.style.setProperty('--history-width', `${historyPanel.offsetWidth}px`);

      } else {
        document.documentElement.style.setProperty('--history-width', `0px`);

      }

    },

    async adjustScrollPosition(dialogElement) {
      if (this.isMobile) {
        return;
      }
      await this.$nextTick()
      // 1. 获取元素位置信息
      const rect = dialogElement.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // 2. 计算元素底部到视口底部的距离
      const bottomSpace = viewportHeight - rect.bottom;
      // 3. 判断是否需要调整（距离小于阈值时）
      let threshold = 300; // 距离阈值(px)

      if (bottomSpace < threshold) {
        dialogElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start' // 或 'start'/'end'
        });
      }
    },
    handleCollapse(chat, cselector) {
      chat.isCollapse = !chat.isCollapse;
      let container = document.querySelector('.' + cselector);
      if (!container) return
      if (chat.isCollapse) {
        let targetEle = container.querySelector('.resizableDiv');
        if (!targetEle) return
        targetEle.style.height = "fit-content";
        targetEle.style.width = "fit-content";
        return;
      } else {
        this.adjustScrollPosition(container)
        this.handleImageLoad(container);
      }
      this.$nextTick(() => {
        // this.copyCode(cselector);
      });
    },
    // ★ 切换智能体时，该智能体无会话 → 自动新建（与刷新时 getRouteInfo 行为保持一致）
    async handleSwitchNewSession(robotId) {
        // 防抖：与 getRouteInfo 互斥，避免同时新建两个会话
        if (this._gettingRouteInfo) return;
        this._gettingRouteInfo = true;
        try {
            store.commit("setRobotId", robotId);
            this.sessionId = "";

            // 更新路由（无真实 sessionId，跳转到不带 sessionId 的路径）
            if (this.$route.params.robotId !== robotId) {
                this.$router.push(`/chatSearch/${robotId}`);
            }

            // 练习类智能体：手动新建并拉取每日一题，与刷新行为一致
            if (robotId === 'exercises' || robotId === 'mexercises') {
                await this.newSession('新会话', { manual: true });
            } else {
                await this.newSession('新会话');
            }
        } catch (error) {
            console.error('handleSwitchNewSession error:', error);
        } finally {
            this._gettingRouteInfo = false;
        }
    },

    async getRouteInfo() {
        // ★ 防重入：newSession 内部会 push 路由，watch 会再次触发，避免死循环
        if (this._gettingRouteInfo) return;
        this._gettingRouteInfo = true;
        try {
            let robotId = this.$route.params.robotId;
            let routeSessionId = this.$route.params.sessionId; // 可能为 undefined

            // ① 更新 store 中的当前 robotId
            store.commit("setRobotId", robotId);

            // ② 等待 IndexedDB 初始化完成（超时 3s 兜底放行）
            if (!this.$store.state.dbInitialized) {
                await new Promise(resolve => {
                    const unwatch = this.$watch(
                        () => this.$store.state.dbInitialized,
                        (val) => {
                            if (val) { unwatch(); resolve(); }
                        }
                    );
                    setTimeout(() => { unwatch(); resolve(); }, 3000);
                });
            }

            // ③ 获取当前智能体的所有会话（按更新时间降序）
            const convs = this.$store.getters.conversationsByAiType(robotId) || [];

            // ④ 决定要激活的会话 ID
            let targetSessionId = null;
            if (routeSessionId) {
                // 路由里是短 id（后10位），用 includes 匹配完整 id
                const existing = convs.find(c => c.id.includes(routeSessionId));
                if (existing) {
                    targetSessionId = existing.id;
                }
            }
            // 路由会话不存在时，回退到该智能体最新的会话
            if (!targetSessionId && convs.length > 0) {
                targetSessionId = convs[0].id;
            }

            // ⑤ 存在有效会话 → 激活它
            if (targetSessionId) {
                await this.$store.dispatch('switchActiveConversation', targetSessionId);
                this.sessionId = targetSessionId;
                store.commit("setSessionId", targetSessionId);
                store.commit("SET_ROBOTSESSIONMAP", { robotId, sessionId: targetSessionId });

                // 注意比较的是短 id（路由中存的是 slice(-10)）
                if (this.$route.params.sessionId !== targetSessionId.slice(-10)) {
                    this.$router.replace(`/chatSearch/${robotId}/${targetSessionId.slice(-10)}`);
                }
                return;
            }

            // ⑥ ★★★ 关键兜底：该智能体在 IndexedDB 中没有任何会话
            //    （无论 robotSessionMap 是否有残留的脏 id）→ 就地新建
            //    这一段就是修复"清空历史会话后切换不新建"的核心
            if (robotId === 'exercises' || robotId === 'mexercises') {
                await this.newSession('新会话', { manual: true });
            } else {
                await this.newSession('新会话');
            }
        } catch (error) {
            console.error('getRouteInfo error:', error);
        } finally {
            this._gettingRouteInfo = false;
        }
    },


    handlePrevent(e) {
      e.preventDefault();
      return;
    },
    saveTestTitle(chat) {
      if (!chat.title) {
        this.$message.warning("请填写试卷名称");
        return
      }
      chat.title = "## " + chat.title;
      chat.isEditTestTitle = false;
      chat.paperCollect = false;
      store.dispatch("updateMessageToConversation", {
        message: chat
      })
    },

    // 打开根据知识点添加题目的对话框
    openPointAddDialog(index, question, chat) {
      this.selectedChat = chat;
      this.selectedQuestion = question;
      this.addQuestionVisible = true;
      this.selectedIndex = index;

    },
    // 打开删除题目的对话框
    openPointDeleteDialog(index, question, chat) {
      this.selectedChat = chat;
      this.selectedQuestion = question;
      this.delQuestionVisible = true;
      this.selectedIndex = index;
    },

    handleQuestionDel() {
      let index = this.selectedIndex;
      this.selectedIndex = "";
      if (index === "") return
      if (this.isLoading) return
      this.isLoading = true
      let type = this.selectedQuestion.question_type
      this.selectedChat.questions[type].questions.splice(index, 1);
      resetQuestionIndex(this.selectedChat.questions)
      this.selectedChat.paperCollect = false;
      this.delQuestionVisible = false;
      this.isLoading = false
      store.dispatch("updateMessageToConversation", {
        message: this.selectedChat
      })
    },
    // 根据知识点添加题目
    async addQuestionByPoint() {
      if (this.isLoading) return
      if (this.selectedIndex === "") return

      this.isLoading = true
      let question = this.selectedQuestion;
      let chat = this.selectedChat;
      let index = this.selectedIndex + 1;
      this.selectedIndex = "";
      let { data: res } = await chatApi.addquestionsBelowByPoint({
        id: question.id,
        level: chat.level,
        query: this.addText
      })
      this.isLoading = false

      if (!res || !res.questions) {
        this.$message.error("增添题目失败");
        return;
      }
      let type = res.questions[0].question_type
      chat.paperCollect = false;
      let questions = initQuestion(res.questions, null, index);
      const newQuestion = questions[type].questions[0];
      // newQuestion.knowledgePoint = question.knowledgePoint;
      chat.questions[type].questions.splice(index, 0, newQuestion);
      resetQuestionIndex(this.selectedChat.questions)
      this.addQuestionVisible = false;
      store.dispatch("updateMessageToConversation", {
        message: chat
      })
    },

    // 题目收藏列表
    async getQuestionCollectionList(type, robotId, sessionId = this.sessionId) {
      if (this.isCollectLoading) return;
      this.isCollectLoading = true;
      try {
        let res = await chatApi.getQustionCollectionList();
        if (!res || res.status != 200) {
          this.isCollectLoading = false;
          return;
        }
        this.handleWrongOrCollectAutoMsg(res.data, type, sessionId, robotId);
        this.isCollectLoading = false;
      } catch (error) {
        console.log(error);
        this.isCollectLoading = false;
      }
    },

    // 错题本
    async getWrongList(type, robotId, sessionId = this.sessionId) {
      try {
        if (this.isWrongLoading) return;
        this.isWrongLoading = true;
        let res = await chatApi.getWrongList();
        if (!res || res.status != 200) {
          this.isWrongLoading = false;
          return;
        }
        this.handleWrongOrCollectAutoMsg(res.data, type, sessionId, robotId);
        this.isWrongLoading = false;
      } catch (error) {
        console.log(error);
        this.isWrongLoading = false;
      }
    },

    // 知识墙
    async getWallList(type, robotId, sessionId = this.sessionId) {
      try {
        if (this.isWallLoading) return;
        this.isWallLoading = true;
        let res = await chatApi.getWallList();
        if (!res || res.status != 200) {
          this.isWallLoading = false;
          return;
        }
        this.handleWallAutoMsg(res.data, type, sessionId, robotId);
        this.isWallLoading = false;
      } catch (error) {
        console.log(error);
        this.isWallLoading = false;
      }
    },
    // 知识图谱
    async getKnowledgeGraphData(type, robotId) {
      let sessionId = this.sessionId;
      let { data } = await chatApi.getKnowledgeGraphData({
        rootName: '数学方法图谱',
        sessionId,
      });
      let autoMsg = createAutoMsg(this.robots[type].avatar, this.$delete);
      autoMsg.msg = "";
      if (!data || !data.kg || !data.kg.name) {
        autoMsg.controller = null;
        autoMsg.parts.push({
          msg: "您的数学图谱方法暂无数据",
        });
      } else {
        this.setAutoMsg(autoMsg, data, type);
        autoMsg.parts.push({
          msg: "",
          questions: {},
          title: data.title || data.kg.name
        });
        autoMsg.title = data.title || data.kg.name;
        autoMsg.paintData = data.kg;
        autoMsg.kgId = data.kgid;
        autoMsg.large = true;
        autoMsg.type = type;
        autoMsg.robotId = robotId;
        autoMsg.sessionId = sessionId
      }
      // 添加用户消息到对话
      await this.$store.dispatch('addMessageToConversation', {
        message: autoMsg
      });
    },

    checkMove(e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    copyCode() {
      this.initCopyCode();
      document.addEventListener('click', this.handleCopyCode);
    },
    handleInteractiveClick() {
      this.initTextClick();
      document.addEventListener('click', this.handleTextClick);
    },
    handleImagePreview() {
      this.imagePreview = (e) => {
        if (e.target.classList.contains('click-enlarge')) {
          this.isModalShow = true;
          this.enlargeSrc = e.target.currentSrc;
        }
      }
      document.addEventListener('click', this.imagePreview)
    },
    // 预览图谱里边的图片
    handleGraphImagePreview(srcUrl) {
      this.isModalShow = true;
      this.enlargeSrc = srcUrl
    },
    handleModal() {
      this.isModalShow = !this.isModalShow
    },
    setAutoMsg(autoMsg, data, type) {
      autoMsg.type = type;
      autoMsg.base64 = data.base64;
      autoMsg.filename = data.filename;
      autoMsg.recommend = data.recommend;
      autoMsg.blockid = data.blockid;
      autoMsg.isDone = 1;
      autoMsg.controller = null;
    },
    // 处理知识墙的接口数据
    async handleWallAutoMsg(data, type, sessionId, robotId) {
      let autoMsg = createAutoMsg(this.robots[type].avatar, this.$delete);
      autoMsg.msg = "";
      autoMsg.sessionId = sessionId;
      autoMsg.robotId = robotId;
      if (!data || Object.keys(data).length == 0) {
        autoMsg.controller = null;
        autoMsg.parts.push({
          msg: "您的知识墙暂无数据",
        });
      } else {
        this.setAutoMsg(autoMsg, data, type);
        autoMsg.parts.push({
          msg: data.content,
        });
        autoMsg.paintData = data;
      }
      // store.commit("UPDATE_MESSAGE", {
      //   robotId,
      //   key: sessionId,
      //   msg: autoMsg,
      //   type,
      // });
      // 添加用户消息到对话
      await this.$store.dispatch('addMessageToConversation', {
        message: autoMsg,
        type
      });
    },
    // 处理错题或收藏题目的消息
    async handleWrongOrCollectAutoMsg(data, type, sessionId, robotId) {
      let autoMsg = createAutoMsg(this.robots[type].avatar, this.$delete);
      this.setAutoMsg(autoMsg, data, type);
      let part = {};
      autoMsg.msg = "";
      part.msg = data.content;
      part.title = data.title;
      let questions = data.questions;
      if (questions.length >= 1) {
        part.questions = initQuestionForList(questions, type);
      }
      autoMsg.parts.push(part);
      autoMsg.sessionId = sessionId;
      autoMsg.robotId = robotId;
      // 添加用户消息到对话
      await this.$store.dispatch('addMessageToConversation', {
        message: autoMsg,
        type,
      });
    },
    // 处理收藏试题
    async handlePaperCollectAutoMsg(data, type, sessionId, robotId) {
      let autoMsg = createAutoMsg(this.robots[type].avatar, this.$delete);
      this.setAutoMsg(autoMsg, data, type);
      autoMsg.paperCollect = true;
      autoMsg.msg = data.content;
      autoMsg.title = data.title;
      autoMsg.level = data.level;
      let questions = data.questions;
      if (questions.length >= 1) {
        autoMsg.questions = initQuestion(questions, type);
      }
      autoMsg.sessionId = sessionId
      autoMsg.robotId = robotId
      // 添加用户消息到对话
      await this.$store.dispatch('addMessageToConversation', {
        message: autoMsg,
        type
      });
    },

    // 处理专题收藏
    handleTopicCollectAutoMsg(data, autoMsg) {
      autoMsg.isDone = 1;
      autoMsg.collectType = "topic"
      if (typeof data === 'object') {
        handleMathData(data, autoMsg)
        store.dispatch("updateMessageToConversation", { message: autoMsg })
        return
      }
      let handleData = `[${data}]`
      handleData = handleData.replaceAll('}\n{', '},{')
      handleData = JSON.parse(handleData)
      handleData.forEach(d => {
        handleMathData(d, autoMsg)
      })
      store.dispatch("updateMessageToConversation", { message: autoMsg })
    },

    // 收藏试题
    async collectPaper(blockid, title, questions, chat) {
      // let questionid = questions.map((item) => item.id);
      if (!title) {
        this.$message.error("请先填写试卷名称再收藏")
        return
      }
      if (chat.isEditTestTitle) {
        this.$message.warning("请修改完名称再收藏")
        return
      }
      let questionid = [];
      for (const type in questions) {
        const typeQuestions = questions[type];
        for (const q of typeQuestions.questions) {
          questionid.push(q.id)
        }
      }
      let res = await chatApi.collectPaper({ blockid, questionid, title, level: chat.level });
      let flag = 200 <= res.status && res.status < 300;
      if (!res || !flag) {
        this.$message.error("收藏失败");
        return;
      }
      if (flag) {
        chat.paperCollect = true;
        this.$message.success("收藏成功");
      }
    },
    // 移除收藏
    async removePaperCollect(blockid, title, questions, chat) {
      // let questionid = questions.map((item) => item.id);

      if (!title) {
        this.$message.error("请先填写试卷名称再收藏")
        return
      }
      if (chat.isEditTestTitle) {
        this.$message.warning("请修改完名称再收藏")
        return
      }
      let questionid = []
      for (const type in questions) {
        const typeQuestions = questions[type];
        for (const q of typeQuestions.questions) {
          questionid.push(q.id)
        }
      }
      let res = await chatApi.removePaperCollect({
        blockid,
        questionid,
        title,
        level: chat.level
      });
      let flag = 200 <= res.status && res.status < 300;
      if (!res || !flag) {
        this.$message.error("未能取消收藏，请稍后再试");
        return;
      }
      if (flag) {
        chat.paperCollect = false;
        this.$message.success("取消成功");
      }
    },

    // 统一的错误处理方法（处理 catch 中的错误）
    async handleDownloadError(error) {
      let errorMsg = "下载失败";
      try {
        if (error.response) {
          const { data, status, statusText } = error.response;
          // 1. 如果 data 是 Blob（常见于设置了 responseType: 'blob' 的下载请求）
          if (data instanceof Blob) {
            const text = await data.text();
            try {
              const json = JSON.parse(text);
              // 尝试从常见字段中提取错误信息
              errorMsg = json.message || json.msg || json.error || text;
            } catch {
              // 不是 JSON，直接使用文本（可能为空字符串）
              errorMsg = text || `HTTP ${status} ${statusText}`;
            }
          }
          // 2. 如果 data 已经是对象（responseType 未设置或为 'json'）
          else if (data && typeof data === 'object') {
            errorMsg = data.message || data.msg || data.error || JSON.stringify(data);
          }
          // 3. 如果 data 是字符串
          else if (typeof data === 'string') {
            errorMsg = data;
          }
          // 4. 其他情况（data 为 null/undefined 等）
          else {
            errorMsg = `HTTP ${status} ${statusText || ''}`.trim();
          }
        }
        // 5. 网络错误（无 response）
        else if (error.message) {
          errorMsg = error.message;
        }
        // 6. 未知错误
        else {
          errorMsg = "未知错误";
        }
      } catch (e) {
        errorMsg = "解析错误信息时发生异常";
      }
      // 确保 errorMsg 不为空
      if (!errorMsg) errorMsg = "下载失败，请稍后重试";
      this.$message.error(errorMsg);
    },


    // 统一的下载处理（支持状态码200时的JSON错误检测）
    async handleDownload(res, name) {
      if (!res) {
        this.$message.error("下载失败：无响应");
        return;
      }

      // 处理非200状态码
      if (res.status !== 200) {
        let errorMsg = `下载失败 (${res.status})`;
        try {
          if (res.data instanceof Blob) {
            const text = await res.data.text();
            try {
              const json = JSON.parse(text);
              errorMsg = json.message || json.error || text;
            } catch {
              errorMsg = text;
            }
          } else if (res.data) {
            if (typeof res.data === 'string') {
              errorMsg = res.data;
            } else if (res.data.message) {
              errorMsg = res.data.message;
            } else if (res.data.error) {
              errorMsg = res.data.error;
            }
          }
        } catch (e) {
          errorMsg = res.statusText || "未知错误";
        }
        this.$message.error(errorMsg);
        return;
      }

      // 状态码200，检查Content-Type是否为JSON
      const contentType = res.headers['content-type'];
      if (contentType && contentType.includes('application/json')) {
        // 响应是JSON，提取错误信息
        let errorMsg = "下载失败";
        try {
          let data = res.data;
          if (data instanceof Blob) {
            const text = await data.text();
            data = JSON.parse(text);
          }
          errorMsg = data.message || data.error || JSON.stringify(data);
        } catch (e) {
          errorMsg = "无法解析错误响应";
        }
        this.$message.error(errorMsg);
        return;
      }

      // 正常下载处理（状态码200且非JSON）
      let filename = "";
      const contentDisposition = res.headers['content-disposition'];
      if (contentDisposition) {
        const matches = contentDisposition.match(/filename="?([^"]+)"?/);
        if (matches) filename = matches[1];
      }
      if (!filename) filename = name + '.docx';

      const blob = new Blob([res.data], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      this.$message.success("下载成功");
    },

    async handleTeacherDownload(chat) {
      try {
        let questionid = [];

        if (chat.parts && chat.parts.length) {
          for (const part of chat.parts) {
            let partIds = [];
            if (part.questions) {
              for (const type in part.questions) {
                const typeQuestions = part.questions[type];
                if (typeQuestions.questions && Array.isArray(typeQuestions.questions)) {
                  for (const q of typeQuestions.questions) {
                    if (q.id) partIds.push(q.id);
                  }
                }
              }
            }
            if (partIds.length) questionid.push(partIds);
          }
        }

        let res = await chatApi.teacherDownload({
          sessionId: this.sessionId,
          blockid: chat.blockid,
          title: chat.parts[0].title,
          questionid: questionid,
        });
        await this.handleDownload(res, chat.blockid);
      } catch (error) {
        await this.handleDownloadError(error);
      }
    },

    async handleStudentDownload(chat) {
      try {
        let questionid = [];

        if (chat.parts && chat.parts.length) {
          for (const part of chat.parts) {
            let partIds = [];
            if (part.questions) {
              for (const type in part.questions) {
                const typeQuestions = part.questions[type];
                if (typeQuestions.questions && Array.isArray(typeQuestions.questions)) {
                  for (const q of typeQuestions.questions) {
                    if (q.id) partIds.push(q.id);
                  }
                }
              }
            }
            if (partIds.length) questionid.push(partIds);
          }
        }

        let res = await chatApi.studentDownload({
          sessionId: this.sessionId,
          blockid: chat.blockid,
          title: chat.parts[0].title,
          questionid: questionid,               
        });
        await this.handleDownload(res, chat.blockid);
      } catch (error) {
        await this.handleDownloadError(error);
      }
    },

    async handleAnswerDownload(chat) {
      if (chat.isAnswerDownloadind) return;
      chat.isAnswerDownloadind = true;
      try {
        let { blockid, questions, title, level } = chat;
        title = title.replaceAll("##", '');
        let questionid = [];
        for (const type in questions) {
          for (const q of questions[type].questions) {
            questionid.push(q.id);
          }
        }
        let res = await chatApi.answerDownload({
          blockid,
          questionid,
          title,
          level
        });
        await this.handleDownload(res, title + '答案');
      } catch (error) {
        await this.handleDownloadError(error);
      } finally {
        chat.isAnswerDownloadind = false;
      }
    },

    async handlePaperDownload(chat) {
      if (chat.isPaperDownloading) return;
      chat.isPaperDownloading = true;
      try {
        let { blockid, questions, title, level } = chat;
        title = title.replaceAll("##", '');
        let questionid = [];
        for (const type in questions) {
          for (const q of questions[type].questions) {
            questionid.push(q.id);
          }
        }
        let res = await chatApi.paperDownload({
          blockid,
          questionid,
          title,
          level
        });
        await this.handleDownload(res, title);
      } catch (error) {
        await this.handleDownloadError(error);
      } finally {
        chat.isPaperDownloading = false;
      }
    },

    toggleEnlarge(img) {
      img.enlarged = !img.enlarged;
    },

    send(obj) {
      obj.available = false;
      obj.type = "info";
      this.$emit("sendMsg", obj.name);
    },
    sendQuestion(q) {
      pubsub.publish("sendRequest", q);
    },
    getFileWrapClass(type) {
      if (type === "other") return "file-wrap";
      if (type === "img") return "img-file-wrap";
    },
    //复制问题
    copyQuestion(question) {
      pubsub.publish("copyText", question);
    },

    // 编辑题目
    editQuestion(e, chat) {
      // this.$set(chat, "isEditTestTitle", true);
      chat.title = chat.title.replace("##", "");
      chat.isEditTestTitle = true;
      let target = e.target;
      let parent = target.parentNode.parentNode;
      this.$nextTick(() => {
        parent.querySelector(".el-input__inner").focus();
      });

    },
    // 订阅消息
    subscribeReceiveDone() {
      pubsub.subscribe("handleReceiveDone", () => { this.clearVisibilityTimer();});
    },
    // 订阅图谱收藏
    subscribeGetGraph() {
      let loading = false;
      pubsub.subscribe("getGraph", async (msg, { kgid, level }) => {
        let robotId = this.robotId;
        if (loading) return;
        loading = true;
        if (!this.activeConversation) {
          await this.newSession(kgid);
        }
        let sessionId = this.sessionId;
        let { data } = await showGraph({ kgid, level });
        loading = false
        if (!data) return
        let autoMsg = createAutoMsg(this.robots.graphCollect.avatar, this.$delete);

        this.setAutoMsg(autoMsg, data, "knowledgeGraph");
        autoMsg.parts.push({
          msg: "",
          questions: {},
          title: data.title || data.kg.name
        });
        autoMsg.paintData = data.kg;
        autoMsg.kgId = data.kgid;
        autoMsg.graphCollect = true;
        autoMsg.msg = "";
        autoMsg.sessionId = sessionId
        autoMsg.robotId = robotId
        // 添加用户消息到对话
        await this.$store.dispatch('addMessageToConversation', {
          message: autoMsg
        });
      });

    },
    // 订阅试题收藏
    subscribeGetPaper() {
      let loading = false;
      pubsub.subscribe("getPaper", async (msg, { paper }) => {
        // 检查当前智能体是否禁用试卷收藏
        if (this.robots[this.robotId]?.disablePaperCollect) {
            this.$message.warning("小学智能体不支持试卷收藏");
            return;
        }
        let robotId = this.robotId;
        let sessionId = this.sessionId;
        if (loading) return;
        loading = true;
        if (!this.activeConversation) {
          await this.newSession(paper.title);
          sessionId = this.sessionId;
        }
        loading = false;
        try {
          if (this.isPaperLoading) return;
          this.isPaperLoading = true;
          let res = await chatApi.showPaper(paper);
          if (!res || res.status != 200) {
            this.isPaperLoading = false;
            return;
          }
          this.handlePaperCollectAutoMsg(
            res.data,
            "paperCollect",
            sessionId,
            robotId
          );
          this.isPaperLoading = false;
        } catch (error) {
          console.log(error);
          this.isPaperLoading = false;
        }
      });
    },
    // 订阅专题收藏
    subscribeGetTopic() {
      let loading = false;
      pubsub.subscribe("getTopic", async (msg, topic) => {
        let robotId = this.robotId;
        let sessionId = this.sessionId;
        if (loading) return;
        loading = true;
        if (!this.activeConversation) {
          await this.newSession(topic.title);
          sessionId = this.sessionId;
        }
        loading = false;
        try {
          if (this.isTopicLoading) return;
          this.isTopicLoading = true;
          let autoMsg = createAutoMsg(this.robots.topicCollect.avatar, this.$delete);
          autoMsg.controller = null;
          autoMsg.robotId = robotId
          autoMsg.sessionId = sessionId
          // 添加用户消息到对话
          await this.$store.dispatch('addMessageToConversation', {
            message: autoMsg,
            type: "topicCollect"
          });
          let res = await chatApi.showTopic(topic);
          if (!res || res.status != 200) {
            this.isTopicLoading = false;
            autoMsg.msg = `${topic.title}请求失败，请稍后再试`
            await this.$store.dispatch('updateMessageToConversation', {
              message: autoMsg
            });
            return;
          }
          this.handleTopicCollectAutoMsg(
            res.data, autoMsg
          );
          this.isTopicLoading = false;
        } catch (error) {
          console.log(error);
          this.isTopicLoading = false;
        }
      });
    },

    // 订阅 我的收藏、错题、知识墙
    subscribeMyQuestions() {
      pubsub.subscribe("getQuestionList", async (msg, { type }) => {
        // 使用实例属性存储loading状态
        if (this.loading) return;
        this.loading = true;

        try {
          let robotId = this.robotId;

          // 提取重复逻辑
          if (!this.activeConversation) {
            await this.newSession();
          }

          switch (type) {
            case "questionCollect":
              // 检查当前智能体是否禁用题目收藏
              if (this.robots[robotId]?.disableQuestionCollect) {
                  this.$message.warning("小学智能体不支持题目收藏");
                  return;
              }
              this.getQuestionCollectionList(type, robotId);
              break;
            case "wrong":
              this.getWrongList(type, robotId);
              break;
            case "wall":
              this.getWallList(type, robotId);
              break;
            case "knowledgeGraph":
              this.getKnowledgeGraphData(type, robotId);
              break;
          }
        } finally {
          // 确保无论成功失败都会重置loading状态
          this.loading = false;
        }
      });
    },
    // 下载文件
    handleDownloadFile(filename) {
      download({ filename }).then((res) => {
        if (res.data.size === 14) {
          // 判定数据库是否存在用户输入文件名
          this.$message("不存在该文件~");
          return;
        } else {
          let filename = JSON.parse(res.config.data).filename; //文件名
          let blob = new Blob([res.data], {
            type: `text/plain;charset=utf-8`,
          });
          // 获取heads中的filename文件名
          let downloadElement = document.createElement("a");
          // 创建下载的链接
          let href = window.URL.createObjectURL(blob);
          downloadElement.href = href;
          // 下载后文件名
          downloadElement.download = filename;
          // appendChild
          document.body.appendChild(downloadElement);
          // 点击下载
          downloadElement.click();
          // 下载完成移除元素
          document.body.removeChild(downloadElement);
          // 释放掉blob对象
          this.$message({
            message: "下载完成",
            type: "success",
          });
        }
      });
    },
    // 链接下载文件
    handleHrefDownload() {
      let links = document.links;
      links = Array.from(links);
      links.forEach((link, index) => {
        let url = decodeURIComponent(link.href);
        if (url.startsWith("sandbox:")) {
          let arr = url.split("/");
          let filename = arr[arr.length - 1];
          link.onclick = (e) => {
            e.preventDefault();
            this.handleDownloadFile(filename);
          };
        }
      });
    },
    async recommandTopic(question, text) {
      if (question) {
        question.isLoading = true;
        // 设置question的滚动问题
        // this.handleQuestionScroll(question);
      }

      let myMsg = {
        type: "my",
        msg: "推荐相似题",
        fileList: [],
        avatar: humenAvatar,
        robotId: this.robotId,
        sessionId: this.sessionId
      };
      let electricaiMsg = createAutoMsg(
        this.robots[this.robotId].avatar,
        this.$delete
      );
      electricaiMsg.sessionId = this.sessionId
      electricaiMsg.robotId = this.robotId
      if (text) {
        myMsg.msg = text;
        // 知识墙点击的选项重新生成
        electricaiMsg.retry = ApiService.fetchWallTopic;
        electricaiMsg.remmandType = "wall";
        electricaiMsg.params = {
          robotId: this.robotId,
          sessionId: this.sessionId,
          text,
        };
      } else {
        electricaiMsg.retry = ApiService.fetchSimilarQuestions;
        electricaiMsg.remmandType = "similar";
        let originMsg = _.clone(electricaiMsg)
        electricaiMsg.params = {
          question,
          aiContent: originMsg,
        };
      }
      // 添加用户消息到对话
      //await this.$store.dispatch('addMessageToConversation', {
      //  message: myMsg
      //});
      // 添加用户消息到对话
      await this.$store.dispatch('addMessageToConversation', {
        message: electricaiMsg
      });
      if (text) {
        ApiService.fetchWallTopic(electricaiMsg, text);
        return;
      }
      ApiService.fetchSimilarQuestions({
        question,
        aiContent: electricaiMsg,
      });
    },
    // 设置答案的滚动问题
    handleQuestionScroll(question) {
      let container = this.$refs.wrapperRef.parentElement;
      let flag = false;
      let title = document.getElementById(question.nanoid + "_title");
      // 题目滚动
      this.$nextTick(() => {
        container.scrollTo({
          top: title.offsetTop,
          behavior: "smooth",
        });
      });
      question.nextTick = (ele) => {
        container.scrollTo({
          top: title.offsetTop,
        });
        // 答案滚到底下
        this.$nextTick(() => {
          ele &&
            ele.scrollTo({
              top: ele.scrollHeight - ele.clientHeight,
              behavior: "smooth",
            });
        });
      };
    },
    sendEditorAnswer(question) {
      question.showAnserPanel = false;
      pubsub.publish("getEditorText", {
        question,
        submitAnswer: this.submitAnswer,
      });
    },
    // 提交答案
    submitAnswer(question, level) {
      resetQuestionStandardAnswer(question)
      question.isViweAnswerCollapse = ""
      question.isTeacherEpxlCollapse = ""
      let { id, userAnswer } = question;
      let answer = "";
      if (userAnswer instanceof Array) {
        if (userAnswer.length === 0) {
          this.$message.warning("答案不能为空");
          question.btn = "";
          return;
        }
        answer = userAnswer.sort().join(",").replaceAll(",", "");
      } else if (!userAnswer.trim()) {
        this.$message.warning("答案不能为空");
        question.btn = "";
        return;
      } else {
        answer = userAnswer;
      }

      question.isLoading = true;
      question.level = level
      // this.handleQuestionScroll(question);
      ApiService.fetchSubmitAnswer({
        id,
        answer,
        question,
      });
    },

    handleChangeAudioVolume() {
      // 点击页面关闭音量键显示
      if (this.$refs.audio) this.$refs.audio.audioHuds = false;
    },
    //下载文件
    downloadFile(filename) {
      this.handleDownloadFile(filename);
    },
    
    // 终止请求
    abortRequest(chat) {
      if (chat.controller && chat.controller.abort) {
        chat.controller.abort();
      }
      chat.isDone = 2;
      chat._aborted = true;
      if ((!chat.msg || chat.msg === 'loading') && (!chat.parts || chat.parts.length === 0)) {
        chat.msg = "请求已取消";
        chat.parts = [{ msg: "请求已取消", questions: {} }];
      }
      this.clearVisibilityTimer();
      
      // ★ 新增：将取消状态同步到 IndexedDB，防止刷新后恢复为加载中
      this.$store.dispatch('updateMessageToConversation', { message: chat });
    },

    // 重新生成
    retry(chat) {
      this.clearVisibilityTimer();
      this.$set(chat, "controller", new AbortController());
      this.$set(chat, "msg", "loading");
      chat.isDone = 0;
      chat.parts = [];

      const title = this.getChatTitle(chat);
      if (!title && ['composition', 'knowledgeGraph', 'topicmark'].includes(chat.type)) {
          this.$message.warning('缺少标题，无法重试');
          return;
      }
      if (!chat.params) chat.params = {};
      chat.params.title = title;

      // 深度研究报告重试
      if (chat.deepResearch) {
        chat.params = {
          questionIds: chat.params.questionIds,
          sessionId: chat.params.sessionId,
          title: title, // 增加 title 字段
        };
        ApiService.fetchDeepResearch(chat);
        return;
      }

      // 知识墙重试
      if (chat.remmandType === "wall") {
        chat.retry(chat, chat.params.text);
        return;
      }
      // 相似题重试
      else if (chat.remmandType === "similar") {
        chat.retry({ ...chat.params, aiContent: chat });
        return;
      }
      // 图谱收藏重试
      else if (chat.type === "graphCollect") {
        this.robots["graphCollect"].getStreamAnswer({
          ...chat.params,
          aiContent: chat,
        });
      }
      // 普通智能体重试
      else {
        this.robots[this.robotId].getStreamAnswer({
          ...chat.params,
          answerUrl: this.robots[this.robotId].answerUrl,
          aiContent: chat,
        });
      }
    },

    async handlerMermaid() {
      await this.$nextTick;
      let autoMsgEle = document.querySelectorAll(
        ".chat-robot .content-wrapper"
      );
      if (!autoMsgEle) return;
      let lastEle = autoMsgEle[autoMsgEle.length - 1];
      if (!lastEle) return;
      let typeEles;
      typeEles = lastEle.querySelectorAll(".language-type");
      typeEles &&
        typeEles.forEach(async (ele, index) => {
          let type = ele.innerText;
          if (type === "mermaid") {
            let codeBlock = ele.parentElement.parentElement;
            let code = codeBlock.querySelector("code");
            const svgGraph = await mermaid.render("graphTD", code.innerText);
            codeBlock.innerHTML = svgGraph.svg;
          }
        });
    },
    // 提取mermain中的表格
    extractMermaidCodeBlocks(chat, markdown) {
      // 正则表达式匹配以 ```mermaid 开始并以 ``` 结束的代码块
      const codeBlockRegex = /```mermaid[\s\S]*?```/g;

      // 使用正则表达式找到所有匹配项
      const codeBlocks = markdown.match(codeBlockRegex);
      // 如果没有找到匹配项，返回空数组
      if (!codeBlocks) {
        return [];
      }
      let svgs = [];
      // 移除代码块前的 ```mermaid 和最后的 ```
      codeBlocks &&
        codeBlocks.map(async (block, index) => {
          block = block.replace("```mermaid", "").replace("```", "");
          const svgGraph = await mermaid.render("graphTD", block);
          svgs.push(svgGraph.svg);
          markdown = markdown.replace(block, "svg" + index);
        });
      // return markdown;
      chat.msg = md.render(markdown);
      svgs.map((svg, index) => {
        return chat.msg.replace("svg" + index, svg);
        // this.$set(chat, msg, chat.msg.replace("svg" + index, svg));
      });
    },

    getSessionIdFromPath(sessionId) {
      let currentSessionId = ""
      for (let conversation of this.conversations) {
        if (conversation.id.includes(sessionId + "")) {
          currentSessionId = conversation.id
          break
        }
      }
      let activeConv = null
      this.conversations.some((conv) => {
        if (conv.id === currentSessionId) {
          activeConv = conv
          return true
        }
      })
      store.commit("setActiveConversation", activeConv)
      return currentSessionId
    },

    handleImageLoad: _.debounce(async function(ele) {
      await this.$nextTick();
      const images = ele ? ele.querySelectorAll('img') : document.querySelectorAll('img');
      if (!images || images.length === 0) return;

      const MAX_RETRIES = 12;
      const RETRY_INTERVAL = 25000; // 25秒
      const MAX_WAIT_MS = 300000; // 5分钟

      images.forEach((img) => {
        // 1. 已成功加载的跳过
        if (img.complete && img.naturalWidth > 0) return;

        // 2. 【关键优化】防止重复绑定监听器，避免内存泄漏
        // 如果该图片已经初始化过监听，则跳过
        if (img._hasImageListener) return;
        img._hasImageListener = true; // 标记已初始化

        let retryCount = 0;
        let retryTimer = null;
        let isStopped = false;

        // 检查图片是否真正可用
        const isImageLoaded = () => img.complete && img.naturalWidth > 0;

        // 执行一次重试（修改 src）
        const performRetry = () => {
          if (isStopped || isImageLoaded()) {
            clearTimeout(retryTimer);
            retryTimer = null;
            return;
          }
          retryCount++;
          if (retryCount > MAX_RETRIES || retryCount * RETRY_INTERVAL > MAX_WAIT_MS) {
            clearTimeout(retryTimer);
            retryTimer = null;
            isStopped = true;
            img.src = ''; // 可替换为占位图
            return;
          }
          const src = img.src;
          if (src && !src.startsWith('data:')) {
            const timestamp = Date.now();
            img.src = `${src}?${timestamp}`;
          }
        };

        // 错误处理：安排下一次重试
        const onError = () => {
          if (isStopped || isImageLoaded()) {
            clearTimeout(retryTimer);
            retryTimer = null;
            return;
          }
          clearTimeout(retryTimer);
          retryTimer = setTimeout(performRetry, RETRY_INTERVAL);
        };

        // 加载完成处理：检查图片是否有效
        const onLoad = () => {
          if (isStopped) return;
          if (isImageLoaded()) {
            clearTimeout(retryTimer);
            retryTimer = null;
            retryCount = 0;
          } else {
            onError();
          }
        };

        // 移除旧监听，绑定新监听
        img.removeEventListener('error', onError);
        img.removeEventListener('load', onLoad);
        img.addEventListener('error', onError);
        img.addEventListener('load', onLoad);

        // 设置一个保护性超时
        let safetyTimer = null;
        const startSafetyTimer = () => {
          clearTimeout(safetyTimer);
          safetyTimer = setTimeout(() => {
            if (!isStopped && !isImageLoaded()) {
              onError();
            }
          }, 30000);
        };

        const clearSafety = () => {
          clearTimeout(safetyTimer);
          safetyTimer = null;
        };

        img.addEventListener('load', clearSafety, { once: true });
        img.addEventListener('error', clearSafety, { once: true });

        // 如果图片未开始加载，主动触发第一次尝试
        if (!img.complete && img.src) {
          setTimeout(() => {
            if (!isStopped && !isImageLoaded()) {
              performRetry();
            }
          }, 100);
        } else if (img.src) {
          startSafetyTimer();
        }
      });
    }, 500), // 防抖时间设置为 500ms

    findParentByClass(child, targetClass) {
      // 从子元素的父元素开始遍历（不包含子元素自身）
      let current = child.parentElement;

      while (current) {
        // 检查当前元素是否包含目标class（使用classList更可靠）
        if (current.classList.contains(targetClass)) {
          return current; // 找到目标，返回父元素
        }
        // 未找到则继续向上遍历
        current = current.parentElement;
      }

      // 遍历至根节点仍未找到，返回null
      return null;
    },
    updateQuestion(question, prop, value) {
      question[prop] = value
    },

    handleScrollBottom(force = false) {
      const el = this.$refs.wrapperRef?.parentElement;
      if (!el) return;

      if (force) {
        // 强制滚动到底部（用于新消息到达）
        el.scrollTop = el.scrollHeight;
        return;
      }

      // 非强制时，只在用户接近底部时才滚动（距离 < 80px）
      const distanceToBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
      if (distanceToBottom < 80) {
        el.scrollTop = el.scrollHeight;
      }
    },
  },
  watch: {
    route: {
        immediate: true,   // ★ 首次挂载即执行，替代 mounted 中的 getRouteInfo() 调用
        async handler(newRoute) {
            if (!newRoute.params || !newRoute.params.robotId) return;
            await this.getRouteInfo();
            // ★ 保留原有逻辑：切换会话后把消息折叠起来
            if (this.chatSize > 0 && this.activeConversation) {
                this.activeConversation.messages.forEach((item) => {
                    this.$set(item, "isCollapse", true);
                    this.$set(item, "isEditTestTitle", false);
                });
            }
        },
    },
    chatSize: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          // 只有消息数量增加时才强制滚动到底部
          const isNewMessage = newVal > oldVal;
          this.handleScrollBottom(isNewMessage);
          this.handleHrefDownload();
          this.handleImageLoad();
          this.handlerMermaid();
          this.handleResize();
        });
      },
    },
    foldHistory(newVal) {
      this.$nextTick(() => {
        this.handleIsFold();

      })

    },
    foldRobot(newVal) {
      this.$nextTick(() => {
        this.handleIsFold();
      })
    },
  },
};
</script>
<style scoped lang='scss'>
.user-msg .content-wrapper {
  margin-left: 12px; // 与机器人消息的 .msg-content 左边距保持一致
}
.msg-header {
  height: 36px; 
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  background: rgba(219, 239, 247, 0.5);
  border-radius: 8px;
  margin-bottom: 4px;
  cursor: default;

  .msg-summary {
    font-size: 16px;
    color: var(--txt-default-color);
    .file-count {
      font-size: 12px;
      color: #999;
      margin-left: 4px;
    }
  }

  .controll-fold {
    margin-left: 8px;
    cursor: pointer;
    i {
      font-size: 20px;
      font-weight: 700;
      color: $base_color;
    }
    .expend {
      transform: rotate(90deg);
    }
  }
}
.virtual-files-wrap {
    margin: 4px 0 4px 16px;  /* 上 右 下 左，与头像保持适当间距 */
    display: flex;
    flex-wrap: wrap;
    .virtual-file-card {
        display: inline-block;
        padding: 6px 14px;
        margin: 4px 8px 4px 0;
        background: #f0f2f5;
        border-radius: 6px;
        border: 1px solid #d9d9d9;
        cursor: pointer;
        font-size: 14px;
        color: #409eff;
        transition: all 0.2s;
        &:hover {
            background: #e6f0ff;
            border-color: #409eff;
        }
    }
}
.speaker-icon {
  display: inline-block;
  margin-left: 12px;
  font-size: 20px;
  cursor: pointer;
  color: #666;
  user-select: none;
  transition: color 0.2s;
}
.speaker-icon:hover {
  color: #409EFF;
}
.speaker-icon.speaking {
  color: #409EFF;
  animation: voiceBeat 1s infinite alternate;
}
@keyframes voiceBeat {
  from { opacity: 0.7; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1.05); }
}

// 标题部分开始
.ai-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  margin: 5px 0;

  .collect-graph {
    margin-top: 4px;
    font-size: 26px;
  }

  ::v-deep h2 {
    margin: 0;
  }

  ::v-deep p {
    margin: 0;
    padding-left: 12px;
    font-size: 20px;
    vertical-align: middle;
  }
}

::v-deep .click-enlarge {
  cursor: pointer;
}

.paper-title {
  padding-left: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title-left {
    display: flex;
    align-items: center;
  }

  ::v-deep h2 {
    margin-left: 12px;
  }

  .collect-wrapper {
    i {
      color: #9dca67;
      font-size: 30px;
    }
  }
}

.controll-fold {
  margin-left: 12px;
  cursor: pointer;

  i {
    padding-top: 3px;
    font-weight: 700;
    font-size: 24px;
    // color: #007bff;
    color: $base_color;
  }

  .expend {
    transform: rotate(90deg);
  }
}

// 标题部分结束
.handler-select {
  margin-right: 15px;
  border-radius: 8px;
}

/* 确保SVG显示正常 */
svg {
  display: inline-block;
  vertical-align: middle;
}


.content {
  border-radius: 10px;
  font-weight: 400;
}

.main-content {
  height: 100%;
}

.right {
  text-align: right;
}

.chat .new {
  display: block;
}

.chat .content {
  width: 100%;
}

.chat img {
  //移动端禁用长按复制
  -webkit-touch-callout: none; //系统默认菜单被禁用
  -webkit-user-select: none; //webkit浏览器
  -moz-user-select: none; //火狐
  -ms-user-select: none; //IE10
  user-select: none;
  pointer-events: none;
}

::v-deep .el-loading-spinner {
  top: 50%;
  margin-top: 0.3rem;
  transform: translate(0, -50%);
  z-index: 2;
}

.container-wrapper {
  padding: 0 54px 0 0;
  margin-bottom: 1rem;
  max-width: calc(100vw - var(--robot-width) - var(--history-width) - 54px);
  min-width: 600px;
  // min-height: 80vh;
}


.paint-wrap {
  width: 88rem;
  padding-top: 4rem !important;
}

.common-wrap {
  width: max-content;
}

.downloadfile-wrap {
  margin: 1rem;

  p {
    font-size: 1rem;
    margin-bottom: 0.8rem;

    &:last-child {
      margin-bottom: 0;
    }

    .el-tag {
      font-size: 16px;
      cursor: pointer;
    }
  }
}

.collapse-section {
  padding: 0 20px;
}



.chat-message {
  margin-top: 1rem;

  .msg-content {
    display: inline-block;
  }

  .collapse-section {
    padding: 0 20px;
  }

  .content-wrapper {
    .reply-content {
      .result {
        margin: 5px 0;
      }
    }

    .my-msg {
      vertical-align: top;
    }
    // 显示链接的图片
    ::v-deep img {
      max-width: 80%;
      /* 高度限制：最大高度不超过屏幕可视区的80%（预留20%边距） */
      max-height: 70vh;
      /* 确保图片比例不变，超出部分裁剪（或使用contain显示完整但可能留空白） */
      object-fit: cover; /* 可选：contain/cover/fill，根据需求选择 */
      /* 避免图片被拉伸变形 */
      height: auto;
      width: auto;

    }
    // 流式生成的base64图片
    ::v-deep img[data-image-type="base64"] {
      width: 90%;
      /* 高度限制：最大高度不超过屏幕可视区的40%（预留60%边距） */
      max-height: 40vh;
      /* 确保图片比例不变，超出部分裁剪（或使用contain显示完整但可能留空白） */
      object-fit: cover; /* 可选：contain/cover/fill，根据需求选择 */
      /* 避免图片被拉伸变形 */
      height: auto;
      width: auto;

    }

    // max-width: 50rem;
    &:has(.knowledge-graph) {
      width: 100%;
      overflow: hidden;

      .collapse-section {
        height: 100%;
      }
    }

    .img-file-wrap {
      padding: 10px 15px 10px 16px;
      width: 380px;

      .el-image {
        width: 100%;
        height: 100%;
        border-radius: 12px;
      }
    }

    .voice-wrap {
      margin: 10px 15px 10px 16px;
    }

    .file-wrap {
      // justify-content: flex-end;
    }
  }
}

.chat-greet {
  margin: 2rem auto 0;
  text-align: center;

  .msg-content {
    padding: 5px 10px;
    background-color: var(--bg-color);
    border-radius: 20px;
    font-size: 14px;
  }
}

.chat-user {
  display: flex;
  // 用户头像与右边缘的距离
  padding-right: 1rem;
  justify-content: flex-start;

  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .msg-content {
      margin: 5px 0.8rem 15px 0;
      padding: 12px 16px 12px 14px;
      line-height: 1.2rem;
      border-radius: 15px 0 15px 15px;
      background-color: $base_color;
      color: #fff;
    }
  }
}

.chat-auto {
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;

  .msg-content {
    margin: 10px 0 15px 12px;
    padding: 6px;
    border-radius: 0 15px 15px 15px;
    background-color: var(--markdown-bg-color);
    overflow: hidden;
    text-align: left;

    &:has(.knowledge-graph) {
      position: relative;
      width: 99%;
      max-height: 1000px;
      min-width: 200px;
      min-height: 200px;
      border: 1px solid transparent;
      overflow: auto;
      resize: both;
      -webkit-resize: both;
      /* 早期 Chrome 需要 */
      -moz-resize: both;
      /* 早期 Firefox 需要 */
      box-sizing: border-box;

      /* 隐藏默认的 resize 图标 */
      &::-webkit-resizer {
        background: none;
      }

      &::-moz-resizer {
        background: none;
      }


      /* 添加自定义的 resize 图标 */
      &::after {
        content: '';
        position: absolute;
        // right: calc(0px - var(--scroll-left, 0px));
        // bottom: calc(5px - var(--scroll-top, 0px));
        right: 0;
        bottom: 0;
        transform: rotate(90deg);
        width: 16px;
        height: 16px;
        background: url('../../assets/image/resize-icon.svg') no-repeat center center;
        /* 使用自定义图标 */
        background-size: cover;
        cursor: se-resize;
        transform: translate(var(--scroll-left, 0), var(--scroll-top, 0));
        will-change: transform;
        /* 提示浏览器优化 */
      }
    }
  }

  .ai-picture {
    margin: 0 auto;
    padding: 0 1rem;
    width: 32rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .ai-img-wrap {
      padding-top: 1rem;
      margin: 0 auto;
      min-width: 14rem;
      min-height: 14rem;
      max-width: 100%;
      max-height: 100%;

      .el-image {
        border-radius: 16px;
      }

      img {
        width: 100%;
        height: 100%;
        // object-fit: contain;
        border-radius: 15px;
        cursor: pointer;
      }

      .enlarge-container {
        position: fixed;
        /* 固定位置在屏幕上 */
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        /* 半透明黑色背景 */
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999999999;
        /* 确保显示在顶层 */
        overflow: auto;
      }

      .enlarged {
        width: 80%;
        /* 设置放大图片的最大宽度 */
        height: 80%;
        object-fit: contain;
        /* 设置图片的放置方式 */
      }
    }
  }
  
  .markdown-body {
    width: 100%;
    background-color: var(--markdown-bg-color);
    color: var(--txt-default-color);
    max-width: calc(100vw - var(--robot-width) - var(--history-width) - 180px);

    ::v-deep p:last-child {
      margin-bottom: 0;
    }

    ::v-deep pre {
      box-sizing: border-box;
      margin: 0;
      margin-bottom: 8px !important;
      background-color: #f6f8fa;
      overflow: auto;
      width: 100%; /* 与父容器.code-block同宽 */

      code {
        width: 100%;
      }
    }
  }

  .some-info {
    margin: 0;
    max-width: 40rem;
  }

  .another-info {
    margin: 0 auto;
    width: 40rem;
  }

.loading-span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #f6f7f9;
  height: 2rem;
  width: auto;
  padding: 0 1rem;
  border-radius: 15px;
  margin: 10px 0 15px 12px;
  
  .el-icon-loading {
    font-size: 16px;
    margin-right: 8px;
    color: #409EFF;
  }
  
  .loading-text {
    font-size: 14px;
    color: #666;
  }
}

  .img-wrap {
    margin: 5px 0 0 8px;
    //自动回复的消息设置padding值
    // padding: 10px;
    margin-left: 32px;
    width: 30px;
    height: 30px;
    border-radius: 20px;
    background: transparent;

    img {
      width: 32px;
      height: 32px;
    }
  }
}

.chat-user {
  margin-right: 1rem;

  img {
    width: 40px;
    height: 40px;
  }
}

.content-span {
  position: relative;

  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .collapse {
    padding-right: 5px;
    position: absolute;
    right: 0;
    bottom: 0;
    line-height: 1.5em;
    cursor: pointer;
  }

  .collapse i {
    width: 15px;
    height: 15px;
    margin-top: -3px;
    display: inline-block;
    vertical-align: middle;
  }

  .collapse i.icon-reduce {
    background-size: 100% auto;
  }

  .collapse i.icon-plus {
    background-size: 100% auto;
  }
}

.top {
  display: none;
}

.request-abort {
  margin-left: 26px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  background: url("~@/assets/image/chat/abort.png") no-repeat center;
  background-size: 100% 100%;
}

.request-fail {
  margin-left: 18px;
  font-size: 14px;

  button {
    background-color:rgba(241, 236, 247, 0.5);
  }
}

.ghost {
  opacity: 0.5;
  background: #cce5ff;
}

.recommend-qs {
  margin-left: 10px;
  margin-top: -10px;
  display: flex;
  flex-wrap: wrap;

  .recommend-item {
    margin-top: 8px;
    margin-bottom: 8px;
    padding: 0 16px;
    margin-right: 20px;
    width: max-content;
    cursor: pointer;
    border-radius: 10px;
    box-shadow: 0 8px 16px var(--recommand-shadow-color, #171212);
    border: 1px solid rgba(26, 32, 41, 0.08);
    background: var(--recommand-bg-color, #2b2e30);
    align-items: center;
    font-size: 14px;
    position: relative;

    ::v-deep p {
      margin: 0;
      padding: 12px 0;
    }

    ::v-deep .wrapper {
      padding: 0;
      overflow-x: auto;
    }

    /* 鼠标悬停样式 */
    &:hover {
      opacity: 1;
      background: var(--bg-color-2);
      transform: translateY(-2px);
      border: 1px solid rgba(26, 32, 41, 0.16);
      cursor: pointer;
    }

    &:hover:before {
      opacity: 0.8;
    }
  }
}

.exercises-wrap {
  .first-question {
    .question-item:first-child {
      border-top: none;
    }
  }

  .question-item {
    padding-top: 10px;
    padding-bottom: 5px;
    border-top: 1px solid var(--border-exercise, #434346);


    /* 防止文本选中 */
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    /* 防止移动端长按菜单 */
    -webkit-touch-callout: none;

    /* 事件处理 */
    pointer-events: auto;

    /* 滚动优化 */
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;

    // /* 额外添加以防止拖拽选中 */
    // -webkit-user-drag: none;
    // -khtml-user-drag: none;
    // -moz-user-drag: none;
    // -o-user-drag: none;
  }
}



::v-deep .markdown-body {
  ::v-deep pre {
    display: flex;
    justify-content: center;
  }

  p:has(img) {
    text-align: center;
    min-height: 100px;
    min-width: 100px;
  }

  p {

    img[data-image-type="base64"] {
      max-width: 80%;
    }
  }
}

::v-deep table {
  // margin-left: 56px;
  margin-top: 6px;
  margin-bottom: 12px;
  // font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-width: 1px;
  border-color: #666666;
  border-collapse: collapse;

  th {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #666666;
    background-color: #dedede;
  }

  td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #666666;
    background-color: #ffffff;
  }
}

.block_operation {
  margin-bottom: 5px;
  padding-top: 18px;
  border-top: 1px solid #c8c8c8;
}

.el-icon-download {
  font-weight: bold;
  color: #fff;
}

.el-select {
  ::v-deep .el-input__inner {
    border: 1px solid $base_color;
    height: 32px !important;

    &::placeholder {
      font-size: 12px;
      color: #a2a1a1;
    }
  }
}

.bueaty-btn {
  margin-right: 10px;
  font-size: 20px;
  color: #fff;
  border-radius: 60px;
  background: linear-gradient(90deg,rgb(6, 22, 247) 0,rgb(153, 4, 190) 100%);
  box-shadow: 0 4px 16px rgba(46, 91, 255, 0.30);
  &:hover {
      transform: translateY(-2px) scale(1.02);
      box-shadow: 0 8px 28px rgba(46, 91, 255, 0.40);
      svg {
          transform: translateY(-1px);
      }
  }

  &:active {
      transform: translateY(0) scale(0.97);
      box-shadow: 0 2px 8px rgba(46, 91, 255, 0.25);
  }
  i {
    color: #fff;
  }

  &:last-child {
    margin-right: 0;
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}


.replaceByPointDialog {
  ::v-deep .el-dialog {
    max-width: 78rem;
    min-width: 60%;

    .el-dialog__body {
      min-height: 180px;
      max-height: 80vh;
      overflow: auto;
      display: flex;
      justify-content: center;
      align-items: center;

      .collect-loading {
        text-align: center;
      }

      .el-loading-parent--relative {
        position: absolute !important;
      }
    }
  }
}


/* 代码块容器 */
::v-deep .code-block {
margin: 0 auto;
width: 90%; 
box-sizing: border-box; /* 确保内边距不影响宽度 */
}

/* 复制行（包含语言标识和复制按钮） */
::v-deep .code-top {
  margin: 0; 
  padding: 6px 12px;
  width: 100%; 
  height: 36px;
  display: flex;
  justify-content: space-between;
  border-radius: 10px 10px 0 0;
  background: var(--hover_icon_grey_2, rgba(79, 88, 102, 0.08)) !important;
  box-sizing: border-box !important;
  color: var(--txt-default-color);

  .language-type {
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
  }

  .copy-btn {
    padding: 2px 8px;
    font-size: 12px;
    border-radius: 6px;
    background: var(--hover_icon_grey_2, rgba(79, 88, 102, 0.08)) !important;

    &:hover {
      cursor: pointer;
      color: $second_blue;
    }
  }
}

.guide-section {
  padding-left: 73px;
  display: flex;
  justify-content: center;
}

.record-wrap {
  overflow: hidden;
}

::v-deep .el-textarea__inner {
  background-color: var(--dialog-bg-color);
  color: var(--txt-default-color);
}

.collapse-section {
  padding: 0 20px;
}

::v-deep .interactive-text {
  color: #3498db;
  cursor: pointer;
  border-bottom: 1px dashed currentColor;

  transition: all 0.2s;
}

::v-deep .interactive-text:hover {
  color: #e74c3c;
  border-bottom-style: solid;
}

::v-deep li:has(.katex) {
  line-height: 2.3;
  font-size: 14px;
}

::v-deep p:has(.katex) {
  line-height: 2.3;
}

::v-deep li:has(.katex)+li:has(.katex) {
  margin-top: 15px;
}

.isMobile {
  .user-msg .msg-content.my-msg {
    display: block;             // 或保留 inline-block
    vertical-align: top;        // 关键：baseline → top，消除行盒上方空隙
  }
  .user-msg .msg-header {
    height: 36px;                // 与桌面高度相近
    padding: 0 8px;              // 只保留左右内边距
    display: flex;
    align-items: center;         // 垂直居中
    font-size: 16px;             // 固定文字大小，避免继承全局放大
    background: rgba(219, 239, 247, 0.5);

    .msg-summary {
      font-size: 14px;
      .file-count {
        font-size: 12px;
      }
    }

    .controll-fold {
      margin-left: 4px;
      i {
        font-size: 18px;         // 图标大小适当放大，保持视觉平衡
        line-height: 1;
        display: inline-flex;
        align-items: center;
        vertical-align: middle;
      }
    }
  }
  // 原有样式保留
  ::v-deep p {
    overflow: auto;
  }

  ::v-deep li {
    margin-left: 12px;
  }

  ::v-deep li:has(.katex) {
    line-height: 2.5;
  }

  ::v-deep p:has(.katex) {
    line-height: 2.8;
  }

  ::v-deep li:has(.katex)+li:has(.katex) {
    margin-top: 5px;
  }

  .guide-section {
    padding-left: 0;
  }

  .request-fail {
    margin-left: 5px;
  }

  @media (hover: none) {
    min-height: 48px;
  }

  .handler-select {
    touch-action: none;
  }

  .el-select-dropdown {
    -webkit-overflow-scrolling: touch;
  }

  &.isKeyboardOpen {
    opacity: 0.2;
  }

  .collapse-section {
    padding: 0 5px;
  }

  /* ★ 修复：内容容器宽度占满 */
  .content-wrapper {
    max-width: 100% !important;          /* 原 calc(100vw - 0.3rem) 改为 100% */
    padding: 0 0.15rem;
    box-sizing: border-box;             /* 确保 padding 不影响宽度 */

    ::v-deep img {
      width: auto;
      max-width: clamp(200px, 90%, 500px);
    }

    ::v-deep img[data-image-type="base64"] {
      width: 80%;
    }
  }

  /* ★ 修复：外层容器确保填满 */
  .container-wrapper {
    margin-bottom: 3vh;
    margin-left: 0;
    padding-right: 0;
    max-width: 100vw !important;
    min-width: 100vw !important;        /* 原 90vw 改为 100vw 确保占满 */
    width: 100% !important;             /* 新增，强制宽度 */
    box-sizing: border-box;

    .chat-greet {
      font-size: 0.18rem;
      margin: 0.3rem auto 0;
    }

    .chat-message {
      margin-top: 0.1rem;
    }

    /* ★ 修复：消息内容宽度占满 */
    .msg-content {
      font-size: $font_size;
      margin: 0.1rem 0 0 0;
      max-width: 100% !important;        /* 原 calc(...) 改为 100% */
      position: relative;
      overflow-x: hidden;
      word-wrap: break-word;
      box-sizing: border-box;
    }
  }

  .paper-title,
  .ai-title {
    ::v-deep h2 {
      font-size: 26px;
    }
  }

  /* ★ 修复：markdown 渲染区域宽度占满 */
  ::v-deep .markdown-body {
    font-size: $font_size;
    max-width: 100% !important;          /* 新增，覆盖桌面端的限制 */
    padding: 0 4px;                     /* 可选，保留微小边距 */
    box-sizing: border-box;
  }

  ::v-deep .markdown-body {
    p {
      margin-bottom: 5px;

      img[data-image-type="base64"] {
        max-width: 100%;
      }
    }

    ol,
    ul {
      padding-left: 10px;
    }
  }

  ::v-deep table {
    margin-left: 0;
    margin: 0 auto;
    max-width: 100% !important;          /* 新增，防止表格溢出 */
    overflow-x: auto;
    display: block;
  }

  .chat-auto {
    .img-wrap {
      margin-left: 0;
      display: none;
    }
  }

  .controll-fold i {
    font-size: 0.3rem;
  }

  .ai-title {
    align-items: center;

    ::v-deep p {
      font-size: $font_size !important;
    }
  }

  .recommend-qs {
    margin-top: 0;
    margin-left: 0;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 3px;

    .recommend-item {
      margin-right: 5px;

      ::v-deep p {
        font-size: clamp(12px, 0.14rem, 16px) !important;
        padding: 8px 0;
        width: max-content;
      }
    }
  }

  .bueaty-btn {
    font-size: 14px;
  }

  .el-select {
    width: 80px !important;
    margin-left: 0;
    margin-right: 6px;

    ::v-deep .el-input {
      font-size: 12px;
    }

    ::v-deep .el-select-dropdown__item {
      padding: 0;
    }
  }

  .loading-span {
    height: 0.5rem;
    padding: 0 0.5rem;
    margin: 0.1rem 0 0 0;

    .el-icon-loading {
      font-size: 14px;
      margin-right: 6px;
    }

    .loading-text {
      font-size: 12px;
    }
  }
}

.warn-info {
  display: flex;
  align-items: center;
  margin: 10% 0 10%;

  .logout-warning {
    line-height: 30px;
    color: #e6a23c;
    font-size: 28px;
    font-weight: 700;
    margin-right: 10px;
  }
}



@media (max-width: 1024px) {

  ::v-deep .collect-radio {
    // margin-right: 6px !important;
  }


  ::v-deep .el-dialog {
    overflow: hidden;


    .el-dialog__header {
      padding: 20px 20px 0;
    }

    .el-dialog__footer {
      padding: 0 24px 20px;
    }


  }

  ::v-deep .el-dialog__body {
    min-height: auto;
    height: 55vh !important;
    max-height: 60vh !important;
    padding-bottom: 8px;
  }


  .replaceByPointDialog {
    height: fit-content !important;

    ::v-deep .el-dialog {
      margin-top: 12vh !important;
      width: 90% !important;

      .el-dialog__body {
        padding-top: 15px;
        padding-bottom: 15px;
        height: auto !important;
        min-height: fit-content;

        .el-textarea__inner {
          margin: 0 auto;
          width: 95%;
          max-height: 420px;
        }
      }

      .el-dialog__footer {
        padding: 0 24px 20px;
      }
    }
  }

  .delDialog {
    ::v-deep .el-dialog {
      margin-top: 10vh;
      min-width: 300px;

      .el-dialog__header {}

      .el-dialog__body {
        height: auto !important;
        padding-top: 10px;
        padding-left: 20px;
      }

      .el-dialog__footer {
        button {
          &:first-child {
            margin-right: 10px;
          }
        }
      }
    }
  }

  ::v-deep .markdown-body {
    font-size: $font_size;
  }

  .markdown-body {
    max-width: fit-content !important;
    font-size: $font_size;

    ::v-deep pre {
      margin-right: 0 !important;
    }

    ::v-deep .code-top {
      margin-right: 0;
    }
  }
}
</style>